import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { teacherPortalAPI, teacherAssignmentsAPI, timeRecordsAPI } from '@/lib/api';
import api from '@/lib/api';
import NotificacoesBell from '@/components/NotificacoesBell';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Textarea } from '@/components/ui/textarea';
import { Checkbox } from '@/components/ui/checkbox';
import { Badge } from '@/components/ui/badge';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { ScrollArea } from '@/components/ui/scroll-area';
import { toast } from 'sonner';
import { 
  GraduationCap, Users, BookOpen, ClipboardList, 
  Calendar, CheckCircle, XCircle, Save, FileText,
  PenLine, Clock, AlertCircle, MapPin, LogIn, LogOut, Coffee, Loader2,
  ExternalLink, Globe, Camera, Calculator, CalendarDays, Upload, Download,
  FileUp, AlertTriangle, Edit, Trash2, Plus, Bell, Send, ArrowLeft,
  Menu, X, Home, DollarSign, BarChart3, Settings, FileSpreadsheet,
  Megaphone, Cake, Trophy, Brain, BookMarked, CreditCard, Building2,
  UserCog, BellRing, Import, Activity, Eraser
} from 'lucide-react';
import { getUser, isAdmin } from '@/lib/auth';
import { TODAS_PAGINAS, CATEGORIAS } from '@/lib/permissoes';
import TeacherScheduleView from '@/components/schedule/TeacherScheduleView';
import RecuperacaoDialog from '@/components/teacher/RecuperacaoDialog';
import AlunosSemNotaDialog from '@/components/teacher/AlunosSemNotaDialog';
import { CienciaBadge } from '@/pages/DnaMapa/CienciaBadge';
import { FaltantesAprovacaoDialog } from '@/components/notas/FaltantesAprovacao';
import { Target } from 'lucide-react';
import { PageHeader } from '@/components/ui-dna';

export default function TeacherPortal({ equipeMode = false }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const user = getUser();
  const userIsAdmin = isAdmin();
  const [loading, setLoading] = useState(true);
  const [myClasses, setMyClasses] = useState([]);
  const [myClassGroups, setMyClassGroups] = useState([]); // Turmas únicas
  const [selectedClassGroup, setSelectedClassGroup] = useState(null); // Turma selecionada
  const [selectedSubject, setSelectedSubject] = useState(null); // Disciplina selecionada dentro da turma
  const [classSubjects, setClassSubjects] = useState([]); // Disciplinas da turma selecionada
  const [selectedClass, setSelectedClass] = useState(null);
  const [showFaltantes, setShowFaltantes] = useState(false);
  const [students, setStudents] = useState([]);
  const [subjects, setSubjects] = useState([]);
  // Status do Motor de Médias (verde/amarelo/vermelho)
  const [classStatusMap, setClassStatusMap] = useState({}); // { cgid: {status, cor, percent} }
  const [subjectStatusMap, setSubjectStatusMap] = useState({}); // { `${cgid}__${sid}`: bucket }
  
  // Grades
  const [gradesDialogOpen, setGradesDialogOpen] = useState(false);
  const [grades, setGrades] = useState([]);
  const [gradeForm, setGradeForm] = useState({
    period: '1º Trimestre',
    evaluation_type: 'APA',
    year: new Date().getFullYear()
  });
  const [studentGrades, setStudentGrades] = useState({});
  
  // Attendance
  const [attendanceDialogOpen, setAttendanceDialogOpen] = useState(false);
  const [attendanceDate, setAttendanceDate] = useState(new Date().toISOString().split('T')[0]);
  const [attendance, setAttendance] = useState({});
  const [attendanceRecords, setAttendanceRecords] = useState([]);
  const [loadingAttendance, setLoadingAttendance] = useState(false);
  const [editingAttendance, setEditingAttendance] = useState(null);
  
  // Lesson Content
  const [contentDialogOpen, setContentDialogOpen] = useState(false);
  const [lessonContents, setLessonContents] = useState([]);
  const [contentForm, setContentForm] = useState({
    date: new Date().toISOString().split('T')[0],
    content: '',
    homework: '',
    observations: ''
  });

  // Consolidação do Boletim
  const [consolidating, setConsolidating] = useState(false);
  const [consolidarDialogOpen, setConsolidarDialogOpen] = useState(false);
  const [trimestreConsolidar, setTrimestreConsolidar] = useState('1º Trimestre');

  // Time Clock (Ponto)
  const [clockDialogOpen, setClockDialogOpen] = useState(false);
  const [clockType, setClockType] = useState('entrada');
  const [location, setLocation] = useState(null);
  const [gettingLocation, setGettingLocation] = useState(false);
  const [locationError, setLocationError] = useState('');
  const [todayRecords, setTodayRecords] = useState([]);
  const [employeeId, setEmployeeId] = useState(null);
  const [distanciaEscola, setDistanciaEscola] = useState(null);
  
  // Justificativa de Ponto
  const [justificativaDialogOpen, setJustificativaDialogOpen] = useState(false);
  const [justificativaTipo, setJustificativaTipo] = useState('atraso');
  const [justificativaTexto, setJustificativaTexto] = useState('');
  const [justificativaDate, setJustificativaDate] = useState(new Date().toISOString().split('T')[0]);
  const [atestadoFile, setAtestadoFile] = useState(null);
  const [uploadingJustificativa, setUploadingJustificativa] = useState(false);

  // Calendário DNA
  const [calendarioDialogOpen, setCalendarioDialogOpen] = useState(false);
  const [calendarioFile, setCalendarioFile] = useState(null);
  const [uploadingCalendario, setUploadingCalendario] = useState(false);
  const [calendarioDisponivel, setCalendarioDisponivel] = useState(null);
  const [viewCalendarioDialogOpen, setViewCalendarioDialogOpen] = useState(false);

  // Atividades/Trabalhos
  const [atividadesDialogOpen, setAtividadesDialogOpen] = useState(false);
  const [atividades, setAtividades] = useState([]);
  const [atividadeForm, setAtividadeForm] = useState({
    titulo: '',
    descricao: '',
    data_entrega: '',
    pontuacao_maxima: 10,
    trimestre: '1º Trimestre'
  });
  const [creatingAtividade, setCreatingAtividade] = useState(false);
  const [atividadeDetalheDialogOpen, setAtividadeDetalheDialogOpen] = useState(false);
  const [atividadeDetalhe, setAtividadeDetalhe] = useState(null);
  const [alertasAtrasados, setAlertasAtrasados] = useState([]);
  const [alertasDialogOpen, setAlertasDialogOpen] = useState(false);
  const [alterarPrazoDialogOpen, setAlterarPrazoDialogOpen] = useState(false);
  const [novoPrazo, setNovoPrazo] = useState('');
  const [alunoSelecionadoPrazo, setAlunoSelecionadoPrazo] = useState(null);

  // Alertas de Reuniões
  const [alertasReunioes, setAlertasReunioes] = useState({ pendentes: [], proximas: [], total_pendentes: 0, total_proximas: 0 });
  const [alertasReunioesDialogOpen, setAlertasReunioesDialogOpen] = useState(false);

  // DNA.IA Dialog (inline)
  const [showDnaIaDialog, setShowDnaIaDialog] = useState(false);
  const [dnaIaQuery, setDnaIaQuery] = useState('');
  const [dnaIaLoading, setDnaIaLoading] = useState(false);
  const [dnaIaResponse, setDnaIaResponse] = useState('');
  const [dnaIaHistory, setDnaIaHistory] = useState([]);

  // Ver Horários Dialog (inline)
  const [showScheduleDialog, setShowScheduleDialog] = useState(false);
  const [showRecuperacaoDialog, setShowRecuperacaoDialog] = useState(false);
  const [showAlunosSemNotaDialog, setShowAlunosSemNotaDialog] = useState(false);
  const [mySchedules, setMySchedules] = useState([]);
  const [loadingSchedules, setLoadingSchedules] = useState(false);

  // Auto-reabre o dialog de Recuperação após retorno do OAuth do Google Classroom
  // (?classroom_connected=1) e existência de pendência salva
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const flag = params.get('classroom_connected');
      const hasPending = !!sessionStorage.getItem('classroom_recovery_pending');
      if (flag === '1' && hasPending) {
        setShowRecuperacaoDialog(true);
        // Remove a flag da URL para evitar reabrir em cada render
        params.delete('classroom_connected');
        const newSearch = params.toString();
        const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : '') + window.location.hash;
        window.history.replaceState({}, '', newUrl);
      }
    } catch (_) { /* noop */ }
  }, []);

  // Semana de Avaliações Dialog
  const [showSemanaAvaliacoesDialog, setShowSemanaAvaliacoesDialog] = useState(false);
  const [semanaAvaliacoes, setSemanaAvaliacoes] = useState([]);
  const [loadingSemanaAvaliacoes, setLoadingSemanaAvaliacoes] = useState(false);

  // Menu lateral e navegação (para equipeMode)
  const [menuOpen, setMenuOpen] = useState(false);
  const [userPermissoes, setUserPermissoes] = useState(null);
  const [currentSection, setCurrentSection] = useState('turmas'); // turmas, alunos, boletim, etc.
  const [iframePage, setIframePage] = useState(null); // Página a ser exibida em iframe
  const [iframeTitle, setIframeTitle] = useState(''); // Título da página no iframe
  const [dnaMapaOk, setDnaMapaOk] = useState(false);
  useEffect(() => { api.get('/dna-mapa/recurso').then(({ data }) => setDnaMapaOk(!!data.can_use)).catch(() => setDnaMapaOk(false)); }, []);
  const abrirDnaMapa = () => window.location.assign(window.location.pathname.startsWith('/equipe') ? '/equipe/dna-mapa' : '/v2/pedagogico/dna-mapa');

  // Ícones para cada categoria
  const CATEGORY_ICONS = {
    financeiro: <DollarSign className="w-4 h-4" />,
    pedagogico: <GraduationCap className="w-4 h-4" />,
    dna_ia: <Brain className="w-4 h-4" />,
    marketing: <Megaphone className="w-4 h-4" />,
    administrativo: <Building2 className="w-4 h-4" />,
    relatorios: <BarChart3 className="w-4 h-4" />
  };

  // Labels traduzidos para categorias
  const CATEGORY_LABELS = {
    financeiro: 'Financeiro',
    pedagogico: 'Pedagógico',
    dna_ia: 'DNA.IA',
    marketing: 'Marketing',
    administrativo: 'Administrativo',
    relatorios: 'Relatórios'
  };

  const periods = ['1º Trimestre', '2º Trimestre', '3º Trimestre'];
  const evaluationTypes = [
    { value: 'APA', label: 'APA' },
    { value: 'Prontidão', label: 'Prontidão' },
    { value: 'Trabalho', label: 'Trabalho' },
    { value: 'Avaliação Trimestral', label: 'Avaliação Trimestral' }
  ];

  // Função para arredondar de 0,5 em 0,5
  const roundToHalf = (num) => {
    return Math.round(num * 2) / 2;
  };

  // Função para calcular média final
  const calculateFinalGrade = (studentId) => {
    const studentGrades = grades.filter(g => 
      g.student_id === studentId && 
      g.grade_type === 'parcial'
    );
    
    if (studentGrades.length === 0) return null;
    
    const sum = studentGrades.reduce((acc, g) => acc + g.grade_value, 0);
    const avg = sum / studentGrades.length;
    return roundToHalf(avg);
  };

  // Função para verificar se está em recuperação
  const isInRecovery = (studentId) => {
    const finalGrade = calculateFinalGrade(studentId);
    return finalGrade !== null && finalGrade < 6.0;
  };

  // Função para obter nota de recuperação geral (final)
  const getGeneralRecoveryGrade = (studentId) => {
    const recoveryGrade = grades.find(g => 
      g.student_id === studentId && 
      g.grade_type === 'recuperacao'
    );
    return recoveryGrade ? recoveryGrade.grade_value : null;
  };

  // Função para calcular nota final após recuperação
  const getFinalGradeAfterRecovery = (studentId) => {
    const avgGrade = calculateFinalGrade(studentId);
    const recoveryGrade = getGeneralRecoveryGrade(studentId);
    
    if (avgGrade === null) return null;
    if (!isInRecovery(studentId)) return avgGrade;
    if (recoveryGrade === null) return avgGrade;
    
    // A nota final é a maior entre a média e a recuperação, limitada a 6,0
    const finalAfterRecovery = Math.max(avgGrade, recoveryGrade);
    return roundToHalf(Math.min(finalAfterRecovery, 6.0));
  };

  // Função para calcular média trimestral (4 avaliações) - usando dados salvos
  const calculateTrimesterAverage = (studentId, period) => {
    const trimesterGrades = evaluationTypes.map(evalType => {
      const grade = grades.find(g => 
        g.student_id === studentId && 
        g.period === period && 
        g.evaluation_type === evalType.value
      );
      return grade ? grade.grade_value : null;
    });
    
    // Só calcula se todas as 4 notas estiverem lançadas
    if (trimesterGrades.some(g => g === null)) return null;
    
    const sum = trimesterGrades.reduce((acc, g) => acc + g, 0);
    const avg = sum / trimesterGrades.length;
    return roundToHalf(avg);
  };

  // Função para calcular média trimestral usando valores do formulário (em tempo real)
  const calculateFormTrimesterAverage = (studentId) => {
    const formGrades = evaluationTypes.map(evalType => {
      const value = studentGrades[`${studentId}_${evalType.value}`];
      if (value === '' || value === null || value === undefined) return null;
      const num = parseFloat(value);
      return isNaN(num) ? null : num;
    });
    
    // Só calcula se todas as 4 notas estiverem preenchidas
    if (formGrades.some(g => g === null)) return null;
    
    const sum = formGrades.reduce((acc, g) => acc + g, 0);
    const avg = sum / formGrades.length;
    return roundToHalf(avg);
  };

  // Função para obter nota de recuperação do formulário
  const getFormRecoveryGrade = (studentId) => {
    const value = studentGrades[`${studentId}_Recuperação`];
    if (value === '' || value === null || value === undefined) return null;
    const num = parseFloat(value);
    return isNaN(num) ? null : num;
  };

  // Função para obter nota de recuperação do trimestre
  const getRecoveryGrade = (studentId, period) => {
    const grade = grades.find(g => 
      g.student_id === studentId && 
      g.period === period && 
      (g.evaluation_type === 'Recuperação' || g.evaluation_type === 'recuperacao' || g.grade_type === 'recuperacao')
    );
    return grade ? grade.grade_value : null;
  };

  // Função para calcular média do trimestre com recuperação
  const calculateTrimesterWithRecovery = (studentId, period) => {
    const trimesterAvg = calculateTrimesterAverage(studentId, period);
    const recovery = getRecoveryGrade(studentId, period);
    
    if (trimesterAvg === null) return null;
    
    // Se tem recuperação e ela é maior que a média trimestral, usa a recuperação
    if (recovery !== null && recovery > trimesterAvg) {
      // Limita a nota de recuperação ao máximo de 6.0
      return Math.min(recovery, 6.0);
    }
    
    return trimesterAvg;
  };

  // Função para calcular média final (3 trimestres, considerando recuperação)
  const calculateFinalAverage = (studentId) => {
    const trimesterAverages = periods.map(period => 
      calculateTrimesterWithRecovery(studentId, period)
    );
    
    // Só calcula se todas as médias trimestrais estiverem disponíveis
    if (trimesterAverages.some(avg => avg === null)) return null;
    
    const sum = trimesterAverages.reduce((acc, avg) => acc + avg, 0);
    const finalAvg = sum / trimesterAverages.length;
    return roundToHalf(finalAvg);
  };

  // Função para obter todas as médias trimestrais de um aluno
  const getAllTrimesterAverages = (studentId) => {
    return periods.map(period => ({
      period,
      average: calculateTrimesterAverage(studentId, period),
      recovery: getRecoveryGrade(studentId, period),
      finalAverage: calculateTrimesterWithRecovery(studentId, period)
    }));
  };

  // Função para carregar notas de um período específico
  const loadGradesForPeriod = async (period) => {
    if (!selectedClass) return;
    
    try {
      const gradesRes = await api.get('/student-grades', {
        params: {
          class_group_id: selectedClass.class_group_id,
          subject_id: selectedClass.subject_id,
          period: period
        }
      });
      
      // Atualizar grades com as notas do período
      setGrades(prevGrades => {
        // Remove grades do período atual e adiciona as novas
        const otherPeriodGrades = prevGrades.filter(g => g.period !== period);
        return [...otherPeriodGrades, ...gradesRes.data];
      });
      
      // Atualizar studentGrades para o formulário
      const periodGrades = {};
      students.forEach(student => {
        // Carregar notas das avaliações regulares
        evaluationTypes.forEach(evalType => {
          const existingGrade = gradesRes.data.find(g => 
            g.student_id === student.id && 
            g.evaluation_type === evalType.value
          );
          periodGrades[`${student.id}_${evalType.value}`] = existingGrade ? existingGrade.grade_value : '';
        });
        // Carregar nota de Recuperação (se existir)
        const recoveryGrade = gradesRes.data.find(g => 
          g.student_id === student.id && 
          (g.evaluation_type === 'Recuperação' || g.evaluation_type === 'recuperacao')
        );
        if (recoveryGrade) {
          periodGrades[`${student.id}_Recuperação`] = recoveryGrade.grade_value;
        }
      });
      setStudentGrades(periodGrades);
    } catch (error) {
      console.error('Error loading grades for period:', error);
    }
  };

  // Função para lidar com mudança de nota individual
  const handleGradeChange = (studentId, evaluationType, value) => {
    setStudentGrades(prev => ({
      ...prev,
      [`${studentId}_${evaluationType}`]: value
    }));
  };

  // Helper para retry com backoff exponencial
  const retryWithBackoff = async (fn, maxRetries = 3, baseDelay = 1000) => {
    let lastError;
    for (let attempt = 0; attempt < maxRetries; attempt++) {
      try {
        return await fn();
      } catch (error) {
        lastError = error;
        if (attempt < maxRetries - 1) {
          const delay = baseDelay * Math.pow(2, attempt);
          await new Promise(resolve => setTimeout(resolve, delay));
        }
      }
    }
    throw lastError;
  };

  // V9.1 · Limpar TODAS as notas do trimestre de um aluno (com confirmação)
  const handleClearTrimester = async (student) => {
    const classGroupId = selectedClass?.class_group_id || selectedClassGroup?.id;
    const subjectId = selectedClass?.subject_id || selectedSubject?.id;
    if (!classGroupId || !subjectId) return toast.error('Nenhuma turma/disciplina selecionada');
    const ok = window.confirm(
      `Limpar TODAS as notas de ${student.name} em ${gradeForm.period} (${gradeForm.year})?\n\n` +
      'APA, Prontidão, Trabalho, Avaliação Trimestral e Recuperação desta disciplina ficarão ' +
      'sem lançamento. A média volta a não calculada e o status a Pendente. Esta ação é auditada.'
    );
    if (!ok) return;
    try {
      const { data } = await api.post('/student-grades/clear-trimester', null, {
        params: { student_id: student.id, period: gradeForm.period, year: gradeForm.year,
                  subject_id: subjectId, class_group_id: classGroupId },
      });
      setStudentGrades(prev => {
        const next = { ...prev };
        Object.keys(next).forEach(k => { if (k.startsWith(`${student.id}_`)) next[k] = ''; });
        return next;
      });
      toast.success(`${data.cleared} nota(s) de ${student.name} apagada(s)`);
      const gradesRes = await api.get('/student-grades', {
        params: { class_group_id: classGroupId, subject_id: subjectId },
      });
      setGrades(gradesRes.data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Falha ao limpar as notas do trimestre');
    }
  };

  // Função para salvar todas as notas do período
  const handleSaveAllGrades = async () => {
    // Usar selectedClass ou construir a partir de selectedClassGroup/selectedSubject
    const classGroupId = selectedClass?.class_group_id || selectedClassGroup?.id;
    const subjectId = selectedClass?.subject_id || selectedSubject?.id;
    const subjectName = selectedClass?.subject?.name || selectedSubject?.name || selectedClass?.subject_name;
    
    if (!classGroupId || !subjectId) {
      toast.error('Nenhuma turma/disciplina selecionada');
      return;
    }
    
    try {
      // Agrupar notas por tipo de avaliação
      const gradesMap = {};
      
      for (const [key, gradeValue] of Object.entries(studentGrades)) {
        // Extrair studentId e evaluationType da chave (formato: "studentId_evalType")
        const parts = key.split('_');
        const studentId = parts[0];
        const evaluationType = parts.slice(1).join('_');
        if (!gradesMap[evaluationType]) gradesMap[evaluationType] = [];

        // V9.1 · CAMPO VAZIO = SEM LANÇAMENTO: envia null para o backend LIMPAR a nota
        // (não salva 0, não salva "-"; a média volta a "não calculada" e o status a Pendente)
        if (gradeValue === '' || gradeValue === null || gradeValue === undefined) {
          gradesMap[evaluationType].push({
            student_id: studentId,
            grade_value: null,
            evaluation_type: evaluationType
          });
          continue;
        }

        let value = parseFloat(gradeValue);
        if (isNaN(value) || value < 0 || value > 10) continue;

        // Arredondar de 0,5 em 0,5
        value = roundToHalf(value);

        gradesMap[evaluationType].push({
          student_id: studentId,
          grade_value: value,
          evaluation_type: evaluationType
        });
      }
      
      // Juntar todas as notas em um único array
      const allGrades = Object.values(gradesMap).flat();
      
      if (allGrades.length === 0) {
        toast.info('Nenhuma nota para salvar');
        return;
      }
      
      // Usar o endpoint bulk com retry
      const response = await retryWithBackoff(async () => {
        return await api.post('/student-grades/bulk', {
          class_group_id: classGroupId,
          subject_id: subjectId,
          subject_name: subjectName,
          period: gradeForm.period,
          year: gradeForm.year,
          grades: allGrades
        });
      }, 3, 2000);
      
      const result = response.data;
      
      if (result.errors && result.errors.length > 0) {
        toast.error(`${result.total} notas salvas, mas ${result.errors.length} erros`);
      } else if (result.cleared) {
        toast.success(`${result.total} nota(s) salva(s) · ${result.cleared} nota(s) apagada(s)`);
      } else {
        toast.success(`${result.total} nota(s) salva(s) com sucesso!`);
      }
      
      setGradesDialogOpen(false);
      
      // Reload all grades
      const gradesRes = await api.get('/student-grades', {
        params: {
          class_group_id: classGroupId,
          subject_id: subjectId
        }
      });
      setGrades(gradesRes.data);
      
    } catch (error) {
      console.error('Erro ao salvar notas:', error);
      const errorMsg = error.code === 'ECONNABORTED' 
        ? 'Timeout - servidor demorou para responder. Tente novamente.'
        : error.code === 'ERR_NETWORK'
        ? 'Erro de conexão - verifique sua internet e tente novamente'
        : error.response?.data?.detail || error.message;
      toast.error('Erro ao salvar notas: ' + errorMsg);
    }
  };

  useEffect(() => {
    loadMyClasses();
    loadEmployeeAndRecords();
    loadCalendarioDisponivel();
    loadAlertasReunioes();
    if (equipeMode) {
      loadUserPermissoes();
    }
  }, []);

  // Carregar permissões do usuário
  const loadUserPermissoes = async () => {
    try {
      const res = await api.get('/users/me');
      
      // Verificar se tem permissões customizadas no usuário
      if (res.data?.permissoes?.paginas) {
        setUserPermissoes(res.data.permissoes.paginas);
      } else if (res.data?.role === 'admin') {
        // Admin tem todas as permissões
        const allPerms = {};
        Object.keys(TODAS_PAGINAS).forEach(p => allPerms[p] = true);
        setUserPermissoes(allPerms);
      } else {
        // Tentar buscar permissões do funcionário vinculado
        try {
          const empRes = await api.get('/employees');
          const emp = empRes.data?.find(e => e.email === res.data?.email);
          if (emp?.permissoes?.paginas) {
            setUserPermissoes(emp.permissoes.paginas);
          }
        } catch (e) {
          console.log('Erro ao buscar permissões do funcionário');
        }
      }
    } catch (error) {
      console.log('Erro ao carregar permissões');
    }
  };

  // Verificar se tem acesso a uma página
  const temAcesso = (paginaId) => {
    if (userIsAdmin) return true;
    if (!userPermissoes) return false;
    return userPermissoes[paginaId] === true;
  };

  // Abrir página em iframe (para equipeMode)
  const abrirPagina = (pagina) => {
    const info = TODAS_PAGINAS[pagina];
    if (info?.path) {
      if (equipeMode) {
        // Abrir em iframe dentro do portal
        setIframePage(info.path);
        setIframeTitle(info.label);
        setCurrentSection('iframe');
      } else {
        navigate(info.path);
      }
    }
    setMenuOpen(false);
  };

  // Fechar iframe e voltar para turmas
  const fecharIframe = () => {
    setIframePage(null);
    setIframeTitle('');
    setCurrentSection('turmas');
  };

  // Carregar alertas de reuniões
  const loadAlertasReunioes = async () => {
    try {
      const res = await api.get('/reunioes/alertas/professor');
      setAlertasReunioes(res.data);
    } catch (error) {
      console.log('Erro ao carregar alertas de reuniões');
    }
  };

  // Responder convite de reunião
  const handleResponderConvite = async (conviteId, resposta) => {
    try {
      await api.put(`/reunioes/convite/${conviteId}/responder`, null, {
        params: { resposta }
      });
      toast.success(resposta === 'confirmado' ? 'Presença confirmada!' : 'Convite recusado');
      loadAlertasReunioes();
    } catch (error) {
      toast.error('Erro ao responder convite');
    }
  };

  // Carregar calendário disponível
  const loadCalendarioDisponivel = async () => {
    try {
      const res = await api.get('/calendario-dna');
      if (res.data && res.data.length > 0) {
        // Pegar o mais recente
        const calendarios = res.data.sort((a, b) => b.ano - a.ano);
        setCalendarioDisponivel(calendarios[0]);
      }
    } catch (error) {
      console.log('Nenhum calendário disponível');
    }
  };

  // Upload do calendário
  const handleUploadCalendario = async () => {
    if (!calendarioFile) {
      toast.error('Selecione um arquivo');
      return;
    }

    setUploadingCalendario(true);
    try {
      const formData = new FormData();
      formData.append('file', calendarioFile);

      await api.post(`/calendario-dna/upload?ano=${new Date().getFullYear()}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      toast.success('Calendário enviado com sucesso!');
      setCalendarioDialogOpen(false);
      setCalendarioFile(null);
      loadCalendarioDisponivel();
    } catch (error) {
      toast.error('Erro ao enviar calendário');
    } finally {
      setUploadingCalendario(false);
    }
  };

  // Download do calendário
  const handleDownloadCalendario = async () => {
    if (!calendarioDisponivel) return;

    try {
      const response = await api.get(`/calendario-dna/download/${calendarioDisponivel.ano}`, {
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', calendarioDisponivel.filename || `calendario_${calendarioDisponivel.ano}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success('Calendário baixado!');
    } catch (error) {
      toast.error('Erro ao baixar calendário');
    }
  };

  // Carregar atividades da disciplina
  const loadAtividades = async () => {
    if (!selectedClassGroup || !selectedSubject) return;

    try {
      const res = await api.get('/atividades', {
        params: {
          class_group_id: selectedClassGroup.id,
          subject_id: selectedSubject.id
        }
      });
      setAtividades(res.data);
    } catch (error) {
      console.error('Erro ao carregar atividades:', error);
    }
  };

  // Carregar alertas de atrasados
  const loadAlertasAtrasados = async () => {
    if (!selectedClassGroup || !selectedSubject) return;

    try {
      const res = await api.get('/atividades/alertas/atrasados', {
        params: {
          class_group_id: selectedClassGroup.id,
          subject_id: selectedSubject.id
        }
      });
      setAlertasAtrasados(res.data);
    } catch (error) {
      console.error('Erro ao carregar alertas:', error);
    }
  };

  // Criar atividade
  const handleCreateAtividade = async () => {
    if (!atividadeForm.titulo || !atividadeForm.data_entrega) {
      toast.error('Preencha título e data de entrega');
      return;
    }

    setCreatingAtividade(true);
    try {
      await api.post('/atividades', {
        ...atividadeForm,
        class_group_id: selectedClassGroup.id,
        subject_id: selectedSubject.id
      });

      toast.success('Atividade criada com sucesso!');
      setAtividadesDialogOpen(false);
      setAtividadeForm({
        titulo: '',
        descricao: '',
        data_entrega: '',
        pontuacao_maxima: 10,
        trimestre: '1º Trimestre'
      });
      loadAtividades();
    } catch (error) {
      toast.error('Erro ao criar atividade');
    } finally {
      setCreatingAtividade(false);
    }
  };

  // Ver detalhes da atividade
  const handleVerAtividade = async (atividade) => {
    try {
      const res = await api.get(`/atividades/${atividade.id}`);
      setAtividadeDetalhe(res.data);
      setAtividadeDetalheDialogOpen(true);
    } catch (error) {
      toast.error('Erro ao carregar detalhes');
    }
  };

  // Registrar entrega
  const handleRegistrarEntrega = async (studentId) => {
    if (!atividadeDetalhe) return;

    try {
      await api.post(`/atividades/${atividadeDetalhe.id}/entregar/${studentId}`);
      toast.success('Entrega registrada!');
      
      // Recarregar detalhes
      const res = await api.get(`/atividades/${atividadeDetalhe.id}`);
      setAtividadeDetalhe(res.data);
      loadAtividades();
      loadAlertasAtrasados();
    } catch (error) {
      toast.error('Erro ao registrar entrega');
    }
  };

  // Alterar prazo
  const handleAlterarPrazo = async () => {
    if (!novoPrazo || !atividadeDetalhe) return;

    try {
      await api.put(`/atividades/${atividadeDetalhe.id}/alterar-prazo`, null, {
        params: {
          nova_data: novoPrazo,
          student_id: alunoSelecionadoPrazo || undefined
        }
      });

      toast.success(alunoSelecionadoPrazo ? 'Prazo alterado para o aluno!' : 'Prazo da atividade alterado!');
      setAlterarPrazoDialogOpen(false);
      setNovoPrazo('');
      setAlunoSelecionadoPrazo(null);
      
      // Recarregar
      const res = await api.get(`/atividades/${atividadeDetalhe.id}`);
      setAtividadeDetalhe(res.data);
      loadAtividades();
      loadAlertasAtrasados();
    } catch (error) {
      toast.error('Erro ao alterar prazo');
    }
  };

  // Deletar atividade
  const handleDeleteAtividade = async (atividadeId) => {
    if (!window.confirm('Deseja realmente excluir esta atividade?')) return;

    try {
      await api.delete(`/atividades/${atividadeId}`);
      toast.success('Atividade excluída');
      setAtividadeDetalheDialogOpen(false);
      loadAtividades();
    } catch (error) {
      toast.error('Erro ao excluir atividade');
    }
  };

  const loadEmployeeAndRecords = async () => {
    try {
      // Get employee ID for current user
      const userRes = await api.get('/users/me');
      const empId = userRes.data?.employee_id;
      
      if (empId) {
        setEmployeeId(empId);
        // Load today's records
        const recordsRes = await timeRecordsAPI.list({ employee_id: empId });
        const today = new Date().toDateString();
        const todayRecs = recordsRes.data.filter(r => 
          new Date(r.timestamp).toDateString() === today
        );
        setTodayRecords(todayRecs);
      }
    } catch (error) {
      console.log('Employee not found for user');
    }
  };

  const loadMyClasses = async () => {
    try {
      // Primeiro, buscar o employee_id do usuário logado
      let myEmployeeId = employeeId;
      if (!myEmployeeId) {
        try {
          const userRes = await api.get('/users/me');
          myEmployeeId = userRes.data?.employee_id;
          if (myEmployeeId) {
            setEmployeeId(myEmployeeId);
          }
        } catch (e) {
          console.log('Não foi possível obter employee_id');
        }
      }

      // Verificar se é coordenação ou secretaria - têm acesso a todas as turmas
      const userRole = user?.role?.toLowerCase();
      const isCoordOrSecretary = userRole === 'coordenacao' || userRole === 'secretaria';
      const hasFullAccess = userIsAdmin || isCoordOrSecretary;

      // Se é admin, coordenação ou secretaria, buscar todas as vinculações
      const assignmentsUrl = (!hasFullAccess && myEmployeeId) 
        ? `/teacher-assignments?teacher_id=${myEmployeeId}`
        : '/teacher-assignments';
      
      const [assignmentsRes, classGroupsRes, subjectsRes] = await Promise.all([
        api.get(assignmentsUrl),
        api.get('/class-groups'),
        api.get('/curriculum-subjects')
      ]);
      
      let assignments = assignmentsRes.data;
      const classGroups = classGroupsRes.data;
      const allSubjects = subjectsRes.data;
      
      // Filtro adicional de segurança no frontend (backup) - NÃO aplicar para coordenação/secretaria
      if (!hasFullAccess && myEmployeeId) {
        assignments = assignments.filter(a => 
          a.teacher_id === myEmployeeId || 
          a.teacher_id === user?.id || 
          a.teacher_email === user?.email
        );
      }
      
      // Enrich assignments with class and subject info
      // Agora o backend já enriquece com subjects[] array
      const enrichedClasses = [];
      
      assignments.forEach(a => {
        const classGroup = classGroups.find(c => c.id === a.class_group_id);
        if (!classGroup) return;
        
        // Usar subjects[] do backend ou fallback para subject_id único
        const assignmentSubjects = a.subjects || [];
        if (assignmentSubjects.length > 0) {
          assignmentSubjects.forEach(sub => {
            enrichedClasses.push({
              ...a,
              class_group: classGroup,
              class_group_id: a.class_group_id,
              subject_id: sub.id,
              subject: { id: sub.id, name: sub.name },
              subject_name: sub.name
            });
          });
        } else if (a.subject_id) {
          const subject = allSubjects.find(s => s.id === a.subject_id);
          if (subject) {
            enrichedClasses.push({
              ...a,
              class_group: classGroup,
              subject: subject
            });
          }
        } else {
          // Vinculação sem disciplinas - ainda mostrar a turma
          enrichedClasses.push({
            ...a,
            class_group: classGroup,
            subject: null
          });
        }
      });
      
      setMyClasses(enrichedClasses.filter(a => a.subject));
      setSubjects(allSubjects);
      
      // Agrupar por turma (sem duplicar)
      const uniqueClassGroups = {};
      enrichedClasses.forEach(a => {
        if (!uniqueClassGroups[a.class_group_id]) {
          uniqueClassGroups[a.class_group_id] = {
            ...a.class_group,
            subjects: [],
            assignments: []
          };
        }
        if (a.subject && !uniqueClassGroups[a.class_group_id].subjects.find(s => s.id === a.subject.id)) {
          uniqueClassGroups[a.class_group_id].subjects.push(a.subject);
        }
        uniqueClassGroups[a.class_group_id].assignments.push(a);
      });
      
      setMyClassGroups(Object.values(uniqueClassGroups));
      
      // Buscar status do motor de médias para feedback visual verde/amarelo/vermelho
      try {
        const params = new URLSearchParams();
        params.append('year', new Date().getFullYear());
        params.append('trimestre', '1º Trimestre');
        if (user?.id) params.append('teacher_id', user.id);
        const statusRes = await api.get(`/grade-engine/status-global?${params}`);
        const buckets = statusRes.data?.buckets || [];
        const subjMap = {};
        const turmaAgg = {};
        for (const b of buckets) {
          subjMap[`${b.class_group_id}__${b.subject_id}`] = b;
          (turmaAgg[b.class_group_id] = turmaAgg[b.class_group_id] || []).push(b.status);
        }
        const turmaMap = {};
        for (const [cgid, arr] of Object.entries(turmaAgg)) {
          const itens = arr.filter(s => s !== 'SEM_ALUNOS');
          if (!itens.length) { turmaMap[cgid] = { status: 'SEM_ALUNOS', cor: '#9CA3AF', percent: 0 }; continue; }
          const completos = itens.filter(s => s === 'COMPLETO').length;
          const criticos = itens.filter(s => s === 'CRITICO').length;
          let status = 'PARCIAL', cor = '#F59E0B';
          if (completos === itens.length) { status = 'COMPLETO'; cor = '#10B981'; }
          else if (criticos === itens.length) { status = 'CRITICO'; cor = '#EF4444'; }
          turmaMap[cgid] = { status, cor, percent: Math.round((completos / itens.length) * 100) };
        }
        setSubjectStatusMap(subjMap);
        setClassStatusMap(turmaMap);
      } catch (_) { /* silencioso */ }
    } catch (error) {
      console.error('Error loading classes:', error);
      toast.error('Erro ao carregar turmas');
    } finally {
      setLoading(false);
    }
  };

  // Deep-link: ler URL params e auto-selecionar turma+disciplina quando vier de notificação
  useEffect(() => {
    const cgid = searchParams.get('class_group_id');
    const subjId = searchParams.get('subject_id');
    if (!cgid || myClassGroups.length === 0 || selectedClassGroup) return;
    
    const cg = myClassGroups.find(g => g.id === cgid);
    if (!cg) return;
    
    handleSelectClassGroup(cg).then(() => {
      if (subjId) {
        const subj = (cg.subjects || []).find(s => s.id === subjId);
        if (subj) {
          setTimeout(() => handleSelectSubject(subj), 100);
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myClassGroups, searchParams]);
  
  const handleSelectClassGroup = async (classGroup) => {
    setSelectedClassGroup(classGroup);
    setSelectedSubject(null);
    setSelectedClass(null);
    setClassSubjects(classGroup.subjects || []);
    
    // Carregar alunos da turma
    try {
      const studentsRes = await api.get('/students');
      const classStudents = studentsRes.data.filter(s => 
        s.class_group_id === classGroup.id || 
        s.class_name === classGroup.name
      );
      setStudents(classStudents);
    } catch (error) {
      toast.error('Erro ao carregar alunos');
    }
  };

  const handleSelectSubject = async (subject) => {
    if (!selectedClassGroup) return;
    
    // Encontrar o assignment correspondente
    const assignment = selectedClassGroup.assignments.find(a => a.subject_id === subject.id);
    if (!assignment) {
      toast.error('Disciplina não encontrada');
      return;
    }
    
    setSelectedSubject(subject);
    setSelectedClass(assignment);
    
    try {
      // Load existing grades for this class/subject
      const gradesRes = await api.get('/student-grades', {
        params: {
          class_group_id: selectedClassGroup.id,
          subject_id: subject.id
        }
      });
      setGrades(gradesRes.data);
      
      // Load lesson contents
      const contentsRes = await api.get('/lesson-contents', {
        params: {
          class_group_id: selectedClassGroup.id,
          subject_id: subject.id
        }
      });
      setLessonContents(contentsRes.data);

      // Load atividades e alertas
      const atividadesRes = await api.get('/atividades', {
        params: {
          class_group_id: selectedClassGroup.id,
          subject_id: subject.id
        }
      });
      setAtividades(atividadesRes.data);

      // Load alertas de atrasados
      const alertasRes = await api.get('/atividades/alertas/atrasados', {
        params: {
          class_group_id: selectedClassGroup.id,
          subject_id: subject.id
        }
      });
      setAlertasAtrasados(alertasRes.data);
    } catch (error) {
      toast.error('Erro ao carregar dados da disciplina');
    }
  };

  const handleSelectClass = async (assignment) => {
    setSelectedClass(assignment);
    try {
      // Load students from the class
      const studentsRes = await api.get('/students');
      const classStudents = studentsRes.data.filter(s => 
        s.class_group_id === assignment.class_group_id || 
        s.class_name === assignment.class_group?.name
      );
      setStudents(classStudents);
      
      // Load existing grades for this class/subject
      const gradesRes = await api.get('/student-grades', {
        params: {
          class_group_id: assignment.class_group_id,
          subject_id: assignment.subject_id
        }
      });
      setGrades(gradesRes.data);
      
      // Load lesson contents
      const contentsRes = await api.get('/lesson-contents', {
        params: {
          class_group_id: assignment.class_group_id,
          subject_id: assignment.subject_id
        }
      });
      setLessonContents(contentsRes.data);
    } catch (error) {
      toast.error('Erro ao carregar dados da turma');
    }
  };

  const handleOpenGrades = async () => {
    // Load existing grades for all evaluation types in the current period
    const initialGrades = {};
    students.forEach(student => {
      evaluationTypes.forEach(evalType => {
        const existingGrade = grades.find(g => 
          g.student_id === student.id && 
          g.period === gradeForm.period && 
          g.evaluation_type === evalType.value
        );
        initialGrades[`${student.id}_${evalType.value}`] = existingGrade ? existingGrade.grade_value : '';
      });
    });
    setStudentGrades(initialGrades);
    setGradesDialogOpen(true);
  };

  const handleSaveGrades = async () => {
    // Usar selectedClass ou construir a partir de selectedClassGroup/selectedSubject
    const classGroupId = selectedClass?.class_group_id || selectedClassGroup?.id;
    const subjectId = selectedClass?.subject_id || selectedSubject?.id;
    const subjectName = selectedClass?.subject?.name || selectedSubject?.name || selectedClass?.subject_name;
    const teacherId = selectedClass?.teacher_id || user?.id;
    
    if (!classGroupId || !subjectId) {
      toast.error('Nenhuma turma/disciplina selecionada');
      return;
    }
    
    try {
      let saved = 0;
      let errors = [];
      
      for (const [key, gradeValue] of Object.entries(studentGrades)) {
        if (gradeValue === '' || gradeValue === null) continue;
        
        // Extrair o studentId e evaluationType da chave (formato: "studentId_evalType")
        const parts = key.split('_');
        const studentId = parts[0];
        const evaluationType = parts.slice(1).join('_'); // evaluation_type pode ter underscore
        
        let value = parseFloat(gradeValue);
        if (isNaN(value) || value < 0 || value > 10) continue;
        
        // Arredondar de 0,5 em 0,5
        value = roundToHalf(value);
        
        try {
          // Check if grade already exists for this period and evaluation type
          const existingGrade = grades.find(g => 
            g.student_id === studentId && 
            g.period === gradeForm.period && 
            g.evaluation_type === evaluationType
          );
          
          if (existingGrade) {
            // Update - send grade_value as query param
            await api.put(`/student-grades/${existingGrade.id}?grade_value=${value}`);
          } else {
            // Create
            await api.post('/student-grades', {
              student_id: studentId,
              class_group_id: classGroupId,
              subject_id: subjectId,
              subject_name: subjectName,
              teacher_id: teacherId,
              grade_type: 'parcial',
              evaluation_type: evaluationType,
              grade_value: value,
              period: gradeForm.period,
              year: gradeForm.year
            });
          }
          saved++;
        } catch (err) {
          console.error('Erro ao salvar nota individual:', err);
          errors.push(`Aluno ${studentId}: ${err.response?.data?.detail || err.message}`);
        }
      }
      
      if (errors.length > 0) {
        toast.error(`Erros ao salvar: ${errors.join(', ')}`);
      } else if (saved > 0) {
        toast.success(`${saved} nota(s) salva(s) com sucesso`);
      } else {
        toast.info('Nenhuma nota para salvar');
      }
      
      setGradesDialogOpen(false);
      
      // Reload grades
      const gradesRes = await api.get('/student-grades', {
        params: {
          class_group_id: classGroupId,
          subject_id: subjectId
        }
      });
      setGrades(gradesRes.data);
    } catch (error) {
      console.error('Erro ao salvar notas:', error);
      toast.error('Erro ao salvar notas: ' + (error.response?.data?.detail || error.message));
    }
  };

  // Handler para lançar nota de recuperação
  const [recoveryDialogOpen, setRecoveryDialogOpen] = useState(false);
  const [recoveryGrades, setRecoveryGrades] = useState({});

  const handleOpenRecovery = () => {
    // Get students in recovery
    const initialRecovery = {};
    students.forEach(s => {
      if (isInRecovery(s.id)) {
        const existingRecovery = grades.find(g => 
          g.student_id === s.id && 
          g.grade_type === 'recuperacao'
        );
        initialRecovery[s.id] = existingRecovery ? existingRecovery.grade_value : '';
      }
    });
    setRecoveryGrades(initialRecovery);
    setRecoveryDialogOpen(true);
  };

  const handleSaveRecovery = async () => {
    // Usar selectedClass ou construir a partir de selectedClassGroup/selectedSubject
    const classGroupId = selectedClass?.class_group_id || selectedClassGroup?.id;
    const subjectId = selectedClass?.subject_id || selectedSubject?.id;
    const subjectName = selectedClass?.subject?.name || selectedSubject?.name || selectedClass?.subject_name;
    const teacherId = selectedClass?.teacher_id || user?.id;
    
    if (!classGroupId || !subjectId) {
      toast.error('Nenhuma turma/disciplina selecionada');
      return;
    }
    
    try {
      let saved = 0;
      for (const [studentId, gradeValue] of Object.entries(recoveryGrades)) {
        if (gradeValue === '' || gradeValue === null) continue;
        
        let value = parseFloat(gradeValue);
        if (isNaN(value) || value < 0 || value > 10) continue;
        
        // Arredondar de 0,5 em 0,5
        value = roundToHalf(value);
        
        // Check if recovery grade already exists
        const existingGrade = grades.find(g => 
          g.student_id === studentId && 
          g.grade_type === 'recuperacao'
        );
        
        if (existingGrade) {
          await api.put(`/student-grades/${existingGrade.id}?grade_value=${value}`);
        } else {
          await api.post('/student-grades', {
            student_id: studentId,
            class_group_id: classGroupId,
            subject_id: subjectId,
            subject_name: subjectName,
            teacher_id: teacherId,
            grade_type: 'recuperacao',
            grade_value: value,
            period: 'Recuperação',
            year: gradeForm.year
          });
        }
        saved++;
      }
      
      toast.success(`${saved} nota(s) de recuperação salva(s)`);
      setRecoveryDialogOpen(false);
      
      // Reload grades
      const gradesRes = await api.get('/student-grades', {
        params: {
          class_group_id: classGroupId,
          subject_id: subjectId
        }
      });
      setGrades(gradesRes.data);
    } catch (error) {
      console.error('Erro ao salvar notas de recuperação:', error);
      toast.error('Erro ao salvar notas de recuperação');
    }
  };

  const handleOpenAttendance = async () => {
    // Usar selectedClass ou construir a partir de selectedClassGroup/selectedSubject
    const classGroupId = selectedClass?.class_group_id || selectedClassGroup?.id;
    const subjectId = selectedClass?.subject_id || selectedSubject?.id;
    
    if (!classGroupId || !subjectId) {
      toast.error('Selecione uma turma/disciplina primeiro');
      return;
    }
    
    // Load existing attendance for the date
    try {
      const attendanceRes = await api.get('/student-attendance', {
        params: {
          class_group_id: classGroupId,
          subject_id: subjectId,
          date: attendanceDate
        }
      });
      
      // Initialize attendance state
      const initialAttendance = {};
      students.forEach(s => {
        const existing = attendanceRes.data.find(a => a.student_id === s.id);
        initialAttendance[s.id] = existing ? existing.present : true;
      });
      setAttendance(initialAttendance);
      setAttendanceDialogOpen(true);
    } catch (error) {
      // Initialize all as present
      const initialAttendance = {};
      students.forEach(s => {
        initialAttendance[s.id] = true;
      });
      setAttendance(initialAttendance);
      setAttendanceDialogOpen(true);
    }
  };

  const handleSaveAttendance = async () => {
    // Usar selectedClass ou construir a partir de selectedClassGroup/selectedSubject
    const classGroupId = selectedClass?.class_group_id || selectedClassGroup?.id;
    const subjectId = selectedClass?.subject_id || selectedSubject?.id;
    const teacherId = selectedClass?.teacher_id || user?.id;
    
    if (!classGroupId || !subjectId) {
      toast.error('Nenhuma turma/disciplina selecionada');
      return;
    }
    
    try {
      const attendanceData = Object.entries(attendance).map(([studentId, present]) => ({
        student_id: studentId,
        present: present
      }));
      
      // Usar retry com backoff para lidar com erros de rede
      await retryWithBackoff(async () => {
        await api.post('/student-attendance/bulk', {
          class_group_id: classGroupId,
          subject_id: subjectId,
          teacher_id: teacherId,
          date: attendanceDate,
          attendance_data: attendanceData
        });
      }, 3, 1000);
      
      toast.success('Chamada salva com sucesso');
      setAttendanceDialogOpen(false);
      // Recarregar faltas
      loadAttendanceRecords();
    } catch (error) {
      console.error('Erro ao salvar chamada:', error);
      const errorMsg = error.code === 'ECONNABORTED' 
        ? 'Timeout - servidor demorou para responder. Tente novamente.'
        : error.code === 'ERR_NETWORK'
        ? 'Erro de conexão - verifique sua internet'
        : error.response?.data?.detail || error.message;
      toast.error('Erro ao salvar chamada: ' + errorMsg);
    }
  };

  // Carregar registros de presença/falta
  const loadAttendanceRecords = async () => {
    const classGroupId = selectedClass?.class_group_id || selectedClassGroup?.id;
    const subjectId = selectedClass?.subject_id || selectedSubject?.id;
    
    if (!classGroupId || !subjectId) return;
    
    setLoadingAttendance(true);
    try {
      const res = await api.get('/student-attendance', {
        params: {
          class_group_id: classGroupId,
          subject_id: subjectId
        }
      });
      setAttendanceRecords(res.data || []);
    } catch (error) {
      console.error('Erro ao carregar faltas:', error);
    } finally {
      setLoadingAttendance(false);
    }
  };

  // Atualizar registro de presença
  const handleUpdateAttendance = async (record, present) => {
    try {
      await api.put(`/student-attendance/${record.id}?present=${present}&justified=${record.justified || false}`);
      toast.success(present ? 'Presença registrada' : 'Falta registrada');
      loadAttendanceRecords();
    } catch (error) {
      toast.error('Erro ao atualizar');
    }
  };

  // Excluir registro de presença
  const handleDeleteAttendance = async (recordId) => {
    if (!window.confirm('Excluir este registro de falta?')) return;
    
    try {
      await api.delete(`/student-attendance/${recordId}`);
      toast.success('Registro excluído');
      loadAttendanceRecords();
    } catch (error) {
      toast.error('Erro ao excluir');
    }
  };

  const handleSaveContent = async () => {
    if (!contentForm.content.trim()) {
      toast.error('Conteúdo é obrigatório');
      return;
    }
    
    // Usar selectedClass ou construir a partir de selectedClassGroup/selectedSubject
    const classGroupId = selectedClass?.class_group_id || selectedClassGroup?.id;
    const subjectId = selectedClass?.subject_id || selectedSubject?.id;
    const teacherId = selectedClass?.teacher_id || user?.id;
    
    if (!classGroupId || !subjectId) {
      toast.error('Nenhuma turma/disciplina selecionada');
      return;
    }
    
    try {
      // Usar retry com backoff para lidar com erros de rede
      await retryWithBackoff(async () => {
        await api.post('/lesson-contents', {
          class_group_id: classGroupId,
          subject_id: subjectId,
          teacher_id: teacherId,
          date: contentForm.date,
          content: contentForm.content,
          homework: contentForm.homework,
          observations: contentForm.observations
        });
      }, 3, 1000);
      
      toast.success('Conteúdo registrado com sucesso');
      setContentDialogOpen(false);
      setContentForm({
        date: new Date().toISOString().split('T')[0],
        content: '',
        homework: '',
        observations: ''
      });
      
      // Reload contents
      const contentsRes = await api.get('/lesson-contents', {
        params: {
          class_group_id: classGroupId,
          subject_id: subjectId
        }
      });
      setLessonContents(contentsRes.data);
    } catch (error) {
      console.error('Erro ao salvar conteúdo:', error);
      const errorMsg = error.code === 'ECONNABORTED' 
        ? 'Timeout - servidor demorou para responder. Tente novamente.'
        : error.code === 'ERR_NETWORK'
        ? 'Erro de conexão - verifique sua internet'
        : error.response?.data?.detail || error.message;
      toast.error('Erro ao salvar conteúdo: ' + errorMsg);
    }
  };

  // Função para consolidar notas e faltas no boletim
  const handleConsolidarBoletim = async () => {
    if (!selectedClassGroup || !selectedSubject) {
      toast.error('Selecione uma turma e disciplina');
      return;
    }

    setConsolidating(true);
    
    try {
      const response = await api.post('/boletim/consolidar', null, {
        params: {
          class_group_id: selectedClassGroup.id,
          subject_id: selectedSubject.id,
          trimestre: trimestreConsolidar
        }
      });
      
      toast.success(
        `Boletim consolidado! ${response.data.consolidados} alunos processados para ${response.data.disciplina} - ${response.data.trimestre}`
      );
      
      if (response.data.erros && response.data.erros.length > 0) {
        toast.warning(`${response.data.erros.length} erros encontrados`);
      }
      
      setConsolidarDialogOpen(false);
    } catch (error) {
      toast.error('Erro ao consolidar boletim: ' + (error.response?.data?.detail || error.message));
    } finally {
      setConsolidating(false);
    }
  };

  // Time Clock Functions
  const getLocation = () => {
    if (!navigator.geolocation) {
      setLocationError('Geolocalização não suportada pelo navegador');
      return;
    }
    
    setGettingLocation(true);
    setLocationError('');
    setDistanciaEscola(null);
    
    // Coordenadas da escola (configuradas)
    const ESCOLA_LAT = -23.618153;
    const ESCOLA_LNG = -46.790322;
    const DISTANCIA_MAXIMA = 100; // PONTO_MAX_DISTANCE_METERS = 100
    
    // Função para calcular distância (Haversine)
    const calcularDistancia = (lat1, lon1, lat2, lon2) => {
      const R = 6371000; // Raio da Terra em metros
      const phi1 = (lat1 * Math.PI) / 180;
      const phi2 = (lat2 * Math.PI) / 180;
      const deltaPhi = ((lat2 - lat1) * Math.PI) / 180;
      const deltaLambda = ((lon2 - lon1) * Math.PI) / 180;
      const a = Math.sin(deltaPhi / 2) ** 2 + Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) ** 2;
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    };
    
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        
        // Calcular distância da escola
        const distancia = calcularDistancia(lat, lng, ESCOLA_LAT, ESCOLA_LNG);
        setDistanciaEscola(Math.round(distancia));
        
        setLocation({
          latitude: lat,
          longitude: lng,
          accuracy: position.coords.accuracy
        });
        setGettingLocation(false);
        
        if (distancia <= DISTANCIA_MAXIMA) {
          toast.success(`Localização capturada! Você está a ${Math.round(distancia)}m da escola.`);
        } else {
          toast.warning(`Você está a ${Math.round(distancia)}m da escola. O limite é ${DISTANCIA_MAXIMA}m.`);
        }
      },
      (error) => {
        setGettingLocation(false);
        let errorMsg = 'Erro ao obter localização';
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMsg = 'Permissão de localização negada. Habilite nas configurações do navegador.';
            break;
          case error.POSITION_UNAVAILABLE:
            errorMsg = 'Localização indisponível no momento.';
            break;
          case error.TIMEOUT:
            errorMsg = 'Tempo esgotado ao obter localização.';
            break;
          default:
            errorMsg = 'Erro desconhecido ao obter localização.';
        }
        setLocationError(errorMsg);
        toast.error(errorMsg);
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  };

  const handleClockIn = async () => {
    if (!employeeId) {
      toast.error('Seu usuário não está vinculado a um funcionário');
      return;
    }
    
    if (!location) {
      toast.error('Capture a localização para registrar o ponto');
      return;
    }
    
    // Verificar distância da escola (30 metros)
    if (distanciaEscola !== null && distanciaEscola > 30) {
      toast.error(`Você está a ${distanciaEscola}m da escola. O ponto só pode ser registrado a até 30m.`);
      return;
    }
    
    try {
      await timeRecordsAPI.create({
        employee_id: employeeId,
        record_type: clockType,
        latitude: location.latitude,
        longitude: location.longitude
      });
      
      toast.success(`Ponto registrado: ${getClockTypeLabel(clockType)}`);
      
      setClockDialogOpen(false);
      setClockType('entrada');
      setLocation(null);
      setDistanciaEscola(null);
      loadEmployeeAndRecords();
    } catch (error) {
      const errorMsg = error.response?.data?.detail || 'Erro ao registrar ponto';
      toast.error(errorMsg);
    }
  };

  // Função para enviar justificativa
  const handleSubmitJustificativa = async () => {
    if (!justificativaTexto.trim()) {
      toast.error('Preencha a justificativa');
      return;
    }
    
    if (!employeeId) {
      toast.error('Seu usuário não está vinculado a um funcionário');
      return;
    }
    
    setUploadingJustificativa(true);
    try {
      let atestadoUrl = null;
      
      // Upload do atestado se houver
      if (atestadoFile) {
        const formData = new FormData();
        formData.append('file', atestadoFile);
        formData.append('folder', 'atestados');
        
        try {
          const uploadRes = await api.post('/upload', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          });
          atestadoUrl = uploadRes.data.url;
        } catch (uploadError) {
          console.error('Erro ao fazer upload:', uploadError);
        }
      }
      
      await api.post('/time-records/justificativa', {
        employee_id: employeeId,
        date: justificativaDate,
        tipo: justificativaTipo,
        justificativa: justificativaTexto,
        atestado_url: atestadoUrl
      });
      
      toast.success('Justificativa enviada com sucesso!');
      setJustificativaDialogOpen(false);
      setJustificativaTexto('');
      setJustificativaTipo('atraso');
      setAtestadoFile(null);
    } catch (error) {
      toast.error('Erro ao enviar justificativa');
    } finally {
      setUploadingJustificativa(false);
    }
  };

  const getClockTypeLabel = (type) => {
    const labels = {
      entrada: 'Entrada',
      saida_almoco: 'Saída Almoço',
      retorno_almoco: 'Retorno Almoço',
      saida: 'Saída'
    };
    return labels[type] || type;
  };

  const getClockTypeIcon = (type) => {
    const icons = {
      entrada: <LogIn className="w-4 h-4 text-green-500" />,
      saida_almoco: <Coffee className="w-4 h-4 text-amber-500" />,
      retorno_almoco: <Coffee className="w-4 h-4 text-blue-500" />,
      saida: <LogOut className="w-4 h-4 text-red-500" />
    };
    return icons[type] || <Clock className="w-4 h-4" />;
  };

  const getStudentGrade = (studentId, period, type) => {
    const grade = grades.find(g => 
      g.student_id === studentId && 
      g.period === period && 
      g.grade_type === type
    );
    return grade ? grade.grade_value : '-';
  };

  // Função para carregar meus horários
  const loadMySchedules = async () => {
    setLoadingSchedules(true);
    try {
      // Buscar employee_id do usuário
      const employeesRes = await api.get('/employees');
      const myEmployee = employeesRes.data.find(e => 
        e.email === user?.email || e.user_id === user?.id
      );
      
      if (myEmployee) {
        const schedulesRes = await api.get(`/class-schedules?employee_id=${myEmployee.id}`);
        setMySchedules(schedulesRes.data || []);
      }
    } catch (error) {
      console.error('Erro ao carregar horários:', error);
    } finally {
      setLoadingSchedules(false);
    }
  };

  // Função para carregar semana de avaliações das turmas do professor
  const loadSemanaAvaliacoes = async () => {
    setLoadingSemanaAvaliacoes(true);
    setSemanaAvaliacoes([]);
    try {
      // Usar as turmas já carregadas do professor (myClassGroups)
      const turmaIds = myClassGroups.map(t => t.id);
      
      if (turmaIds.length === 0) {
        toast.info('Você não possui turmas vinculadas');
        return;
      }
      
      // Buscar avaliações para cada turma
      const avaliacoesPorTurma = [];
      for (const turmaId of turmaIds) {
        try {
          const response = await api.get(`/assessment-week/connect/avaliacoes-por-turma?turma_id=${turmaId}`);
          if (response.data.semanas && response.data.semanas.length > 0) {
            avaliacoesPorTurma.push(...response.data.semanas);
          }
        } catch (e) {
          // Turma sem avaliação publicada, ignorar
        }
      }
      
      setSemanaAvaliacoes(avaliacoesPorTurma);
      
      if (avaliacoesPorTurma.length === 0) {
        toast.info('Nenhuma semana de avaliações publicada para suas turmas');
      }
    } catch (error) {
      console.error('Erro ao carregar semana de avaliações:', error);
      toast.error('Erro ao carregar semana de avaliações');
    } finally {
      setLoadingSemanaAvaliacoes(false);
    }
  };

  // Função para DNA.IA
  const handleDnaIaAsk = async () => {
    if (!dnaIaQuery.trim()) return;
    
    setDnaIaLoading(true);
    try {
      const response = await api.post('/dna-ia/chat', {
        message: dnaIaQuery,
        context: {
          class_group_id: selectedClassGroup?.id,
          subject_id: selectedSubject?.subject_id,
          class_name: selectedClassGroup?.name,
          subject_name: selectedSubject?.subject_name
        }
      });
      
      const newMessage = {
        question: dnaIaQuery,
        answer: response.data.response || response.data.message || 'Resposta recebida',
        timestamp: new Date().toISOString()
      };
      
      setDnaIaHistory(prev => [...prev, newMessage]);
      setDnaIaResponse(newMessage.answer);
      setDnaIaQuery('');
    } catch (error) {
      const errorMsg = error.response?.data?.detail || 'Erro ao consultar DNA.IA';
      toast.error(errorMsg);
      setDnaIaResponse('Desculpe, ocorreu um erro ao processar sua pergunta.');
    } finally {
      setDnaIaLoading(false);
    }
  };

  // Dias da semana
  const DIAS_SEMANA = [
    { id: 'segunda', label: 'Seg' },
    { id: 'terca', label: 'Ter' },
    { id: 'quarta', label: 'Qua' },
    { id: 'quinta', label: 'Qui' },
    { id: 'sexta', label: 'Sex' }
  ];

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className={equipeMode ? "min-h-screen bg-gray-50" : "p-4 sm:p-6 space-y-4 sm:space-y-6"}>
      {/* Header DNA Design System (equipeMode) */}
      {equipeMode && (
        <header className="dna-header-gradient text-white shadow-lg sticky top-0 z-50 safe-area-inset" data-testid="teacher-portal-header-equipe">
          <div className="max-w-7xl mx-auto px-3 sm:px-4 py-2 sm:py-3 relative">
            <div className="pointer-events-none absolute -top-12 -right-12 w-40 h-40 rounded-full bg-emerald-400/20 blur-3xl" />
            <div className="relative flex items-center justify-between">
              <div className="flex items-center gap-2 sm:gap-3">
                <Button 
                  variant="ghost" 
                  size="sm"
                  className="text-white hover:bg-white/20 p-2 touch-target"
                  onClick={() => setMenuOpen(!menuOpen)}
                  data-testid="portal-menu-toggle"
                >
                  {menuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                </Button>
                <div className="flex items-center gap-2">
                  <img 
                    src="/novo-dna-logo.png" 
                    alt="NOVO DNA" 
                    className="h-8 w-auto object-contain hidden sm:block"
                  />
                  <div>
                    <h1 className="text-base sm:text-lg font-bold">Portal Equipe</h1>
                    <p className="text-violet-100/85 text-[10px] sm:text-xs truncate max-w-[120px] sm:max-w-none">Olá, {user?.name}</p>
                  </div>
                </div>
              </div>
              <div className="flex gap-1 sm:gap-2 items-center">
                <NotificacoesBell userId={user?.id} theme="dark" />
                <Button 
                  variant="outline" 
                  size="sm"
                  className="bg-white/15 border-white/25 text-white hover:bg-white/25 px-2 sm:px-3"
                  onClick={() => setClockDialogOpen(true)}
                >
                  <Camera className="w-4 h-4 sm:mr-1" />
                  <span className="hidden sm:inline">Ponto</span>
                </Button>
                <Button 
                  variant="outline" 
                  size="sm"
                  className="bg-white/15 border-white/25 text-white hover:bg-white/25 px-2 sm:px-3"
                  onClick={() => {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    localStorage.removeItem('portal_equipe');
                    navigate('/equipe');
                  }}
                >
                  <LogOut className="w-4 h-4 sm:mr-1" />
                  <span className="hidden sm:inline">Sair</span>
                </Button>
              </div>
            </div>
          </div>
        </header>
      )}
      
      {/* Menu Lateral - responsivo com overlay */}
      {equipeMode && menuOpen && (
        <div className="fixed inset-0 z-40 flex">
          {/* Overlay com blur */}
          <div 
            className="fixed inset-0 bg-black/50 backdrop-blur-sm" 
            onClick={() => setMenuOpen(false)}
          />
          
          {/* Menu - largura responsiva */}
          <div className="relative w-[280px] sm:w-72 bg-white shadow-xl overflow-y-auto safe-area-inset">
            <div className="p-3 sm:p-4 border-b bg-purple-50">
              <h2 className="font-bold text-purple-800 text-sm sm:text-base">Menu de Funcionalidades</h2>
              <p className="text-[10px] sm:text-xs text-purple-600">Acesse todas as funções disponíveis</p>
            </div>
            
            <ScrollArea className="h-[calc(100vh-120px)]">
              <div className="p-2">
                {/* Botão voltar para Turmas */}
                <Button
                  variant="ghost"
                  className="w-full justify-start mb-2 text-purple-700 hover:bg-purple-50 text-sm"
                  onClick={() => { setMenuOpen(false); setCurrentSection('turmas'); }}
                >
                  <Home className="w-4 h-4 mr-2" />
                  Minhas Turmas
                </Button>
                {dnaMapaOk && (
                  <Button variant="ghost" className="w-full justify-start mb-2 h-auto py-2 text-left text-sm text-purple-800 bg-purple-50/60 hover:bg-purple-100" onClick={() => { setMenuOpen(false); abrirDnaMapa(); }} data-testid="menu-dna-mapa">
                    <Brain className="w-4 h-4 mr-2 shrink-0" />
                    <span className="whitespace-normal leading-tight">DNA MAPA — Diagnóstico e Aprendizagem</span>
                  </Button>
                )}
                
                {CATEGORIAS.map(categoria => {
                  // Filtrar páginas da categoria que o usuário tem acesso
                  const paginasCategoria = Object.entries(TODAS_PAGINAS)
                    .filter(([id, info]) => info.categoria === categoria && temAcesso(id));
                  
                  if (paginasCategoria.length === 0) return null;
                  
                  return (
                    <div key={categoria} className="mb-3">
                      <div className="flex items-center gap-2 px-2 py-1 text-[10px] sm:text-xs font-semibold text-gray-500 uppercase">
                        {CATEGORY_ICONS[categoria]}
                        {CATEGORY_LABELS[categoria]}
                      </div>
                      {paginasCategoria.map(([paginaId, info]) => (
                        <Button
                          key={paginaId}
                          variant="ghost"
                          className="w-full justify-start text-xs sm:text-sm h-9 hover:bg-gray-100"
                          onClick={() => abrirPagina(paginaId)}
                        >
                          {info.label}
                        </Button>
                      ))}
                    </div>
                  );
                })}
              </div>
            </ScrollArea>
          </div>
        </div>
      )}
      
      <div className={equipeMode ? "max-w-7xl mx-auto px-3 sm:px-4 mt-3 sm:mt-4" : ""}>
      
      {/* Iframe para exibir páginas do sistema */}
      {equipeMode && currentSection === 'iframe' && iframePage && (
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="flex items-center justify-between px-4 py-2 bg-purple-100 border-b">
            <div className="flex items-center gap-2">
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={fecharIframe}
                className="h-8 w-8 p-0"
              >
                <ArrowLeft className="w-4 h-4" />
              </Button>
              <h2 className="font-semibold text-purple-800">{iframeTitle}</h2>
            </div>
            <Button 
              variant="outline" 
              size="sm"
              onClick={fecharIframe}
            >
              <X className="w-4 h-4 mr-1" />
              Fechar
            </Button>
          </div>
          <iframe 
            src={iframePage}
            className="w-full border-0"
            style={{ height: 'calc(100vh - 180px)', minHeight: '600px' }}
            title={iframeTitle}
          />
        </div>
      )}
      
      {/* Conteúdo normal (turmas) - mostrar apenas quando não está em iframe */}
      {(!equipeMode || currentSection !== 'iframe') && (
      <>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        {!equipeMode && (
        <div className="w-full" data-testid="teacher-portal-page-header-wrapper">
          <PageHeader
            icon={GraduationCap}
            eyebrow="Acadêmico · DNACore V2"
            title="Portal Equipe DNA"
            subtitle={user?.name ? `Bem-vindo, ${user.name}` : 'Bem-vindo'}
          />
          <h1 className="sr-only" data-testid="teacher-portal-title">Portal Equipe DNA</h1>
        </div>
        )}
        <div className="flex flex-wrap items-center gap-2">
          {dnaMapaOk && (
            <Button variant="outline" onClick={abrirDnaMapa} className="border-purple-300 bg-purple-50 text-purple-800 hover:bg-purple-100" data-testid="btn-dna-mapa-topo">
              <Brain className="w-4 h-4 mr-2 text-purple-700" />
              DNA MAPA — Diagnóstico e Aprendizagem
            </Button>
          )}
          <CienciaBadge />
          {/* Botão Agenda */}
          <Button 
            variant="outline" 
            onClick={() => setAlertasReunioesDialogOpen(true)}
            className="border-blue-200 bg-blue-50/50 hover:bg-blue-100 relative"
          >
            <Calendar className="w-4 h-4 mr-2 text-blue-600" />
            Agenda
            {(alertasReunioes.total_pendentes > 0) && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                {alertasReunioes.total_pendentes}
              </span>
            )}
          </Button>

          {/* Botão Calendário DNA */}
          <Button 
            variant="outline" 
            onClick={() => calendarioDisponivel ? setViewCalendarioDialogOpen(true) : setCalendarioDialogOpen(true)}
            className="border-purple-200 bg-purple-50/50 hover:bg-purple-100"
          >
            <CalendarDays className="w-4 h-4 mr-2 text-purple-600" />
            Calendário DNA
          </Button>
          
          {/* Botão Bater Ponto - disponível para todos */}
          {!equipeMode && (
          <>
            <Button onClick={() => setClockDialogOpen(true)} data-testid="clock-in-btn">
              <Camera className="w-4 h-4 mr-2" />
              Bater Ponto
            </Button>
            <Button 
              variant="outline" 
              onClick={() => setJustificativaDialogOpen(true)}
              className="border-orange-300 text-orange-700 hover:bg-orange-50"
            >
              <FileText className="w-4 h-4 mr-2" />
              Justificar
            </Button>
            <Button 
              variant="outline" 
              onClick={() => {
                setShowSemanaAvaliacoesDialog(true);
                loadSemanaAvaliacoes();
              }}
              className="border-purple-300 text-purple-700 hover:bg-purple-50"
            >
              <ClipboardList className="w-4 h-4 mr-2" />
              Avaliações
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/equipe/avaliacoes/editor')}
              className="border-indigo-300 text-indigo-700 hover:bg-indigo-50"
              data-testid="btn-editor-avaliacoes"
            >
              <FileText className="w-4 h-4 mr-2" />
              Editor de Avaliações
            </Button>
          </>
          )}
          
          {/* Botões de Ponto para modo Equipe (admin) */}
          {equipeMode && (
          <>
            <Button onClick={() => setClockDialogOpen(true)} data-testid="clock-in-btn">
              <Camera className="w-4 h-4 mr-2" />
              Bater Ponto
            </Button>
            <Button 
              variant="outline" 
              onClick={() => setJustificativaDialogOpen(true)}
              className="border-orange-300 text-orange-700 hover:bg-orange-50"
            >
              <FileText className="w-4 h-4 mr-2" />
              Justificar
            </Button>
            <Button 
              variant="outline" 
              onClick={() => {
                setShowSemanaAvaliacoesDialog(true);
                loadSemanaAvaliacoes();
              }}
              className="border-purple-300 text-purple-700 hover:bg-purple-50"
            >
              <ClipboardList className="w-4 h-4 mr-2" />
              Avaliações
            </Button>
          </>
          )}
        </div>
      </div>

      {/* Alerta de Reuniões Pendentes */}
      {alertasReunioes.total_pendentes > 0 && (
        <Alert className="border-blue-200 bg-blue-50">
          <Calendar className="h-4 w-4 text-blue-600" />
          <AlertDescription>
            <div className="flex justify-between items-center">
              <span className="font-medium text-blue-800">
                Você tem {alertasReunioes.total_pendentes} convite(s) de reunião pendente(s)
              </span>
              <Button 
                variant="outline" 
                size="sm"
                className="border-blue-300 hover:bg-blue-100"
                onClick={() => setAlertasReunioesDialogOpen(true)}
              >
                <Calendar className="w-4 h-4 mr-2" />
                Ver Convites
              </Button>
            </div>
          </AlertDescription>
        </Alert>
      )}

      {/* Today's Time Records */}
      {employeeId && todayRecords.length > 0 && (
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-base flex items-center gap-2">
              <Clock className="w-5 h-5" />
              Meu Ponto Hoje - {new Date().toLocaleDateString('pt-BR')}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex flex-wrap gap-4">
              {todayRecords.map(record => (
                <div key={record.id} className="flex items-center gap-2 px-3 py-2 bg-muted rounded-lg">
                  {getClockTypeIcon(record.record_type)}
                  <span className="font-medium">{getClockTypeLabel(record.record_type)}</span>
                  <span className="text-muted-foreground">
                    {new Date(record.timestamp).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                  </span>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {!selectedClassGroup ? (
        // Seleção de Turma
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <h2 className="text-base sm:text-lg font-semibold">Minhas Turmas</h2>
            <div className="flex items-center gap-2">
              <Button 
                variant="outline" 
                size="sm"
                onClick={() => setShowScheduleDialog(true)}
                className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3"
              >
                <CalendarDays className="w-4 h-4" />
                <span className="hidden sm:inline">Ver Horários</span>
              </Button>
              {(() => {
                const role = String(user?.role || '').toLowerCase();
                const canSee = ['professor', 'teacher', 'coordenacao', 'admin'].includes(role);
                if (!canSee) return null;
                return (
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setShowRecuperacaoDialog(true)}
                    className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 border-amber-300 text-amber-800 hover:bg-amber-50"
                    data-testid="btn-alunos-recuperacao"
                  >
                    <AlertTriangle className="w-4 h-4" />
                    <span className="hidden sm:inline">Alunos em Recuperação</span>
                  </Button>
                );
              })()}
              {(() => {
                const role = String(user?.role || '').toLowerCase();
                const canSee = ['professor', 'teacher', 'coordenacao', 'admin', 'secretaria'].includes(role);
                if (!canSee) return null;
                return (
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setShowAlunosSemNotaDialog(true)}
                    className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 border-rose-300 text-rose-800 hover:bg-rose-50"
                    data-testid="btn-alunos-sem-nota"
                  >
                    <ClipboardList className="w-4 h-4" />
                    <span className="hidden sm:inline">Alunos sem Nota</span>
                  </Button>
                );
              })()}
            </div>
          </div>
          
          {myClassGroups.length === 0 ? (
            <Card>
              <CardContent className="p-6 sm:p-8 text-center">
                <GraduationCap className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-3 sm:mb-4 text-muted-foreground opacity-50" />
                <p className="text-sm sm:text-base text-muted-foreground">
                  Nenhuma turma vinculada a você.
                </p>
                <p className="text-xs sm:text-sm text-muted-foreground mt-2">
                  Solicite ao administrador que vincule você às suas turmas e disciplinas.
                </p>
              </CardContent>
            </Card>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
              {myClassGroups.map((classGroup) => {
                const ts = classStatusMap[classGroup.id];
                const tsColor = ts?.cor;
                const tsLabel = ts ? (ts.status === 'COMPLETO' ? 'Completo' : ts.status === 'PARCIAL' ? `${ts.percent}% Completo` : ts.status === 'CRITICO' ? 'Crítico' : '') : '';
                return (
                <Card 
                  key={classGroup.id} 
                  className="cursor-pointer hover:border-primary transition-colors active:scale-[0.98]"
                  onClick={() => handleSelectClassGroup(classGroup)}
                  data-testid={`class-card-${classGroup.id}`}
                  style={tsColor ? { borderLeft: `4px solid ${tsColor}` } : {}}
                >
                  <CardHeader className="p-4 sm:p-6">
                    <div className="flex items-center gap-2 sm:gap-3">
                      <div className="p-1.5 sm:p-2 bg-primary/10 rounded-lg flex-shrink-0">
                        <GraduationCap className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2">
                          <CardTitle className="text-sm sm:text-base truncate">
                            {classGroup.name || 'Turma'}
                          </CardTitle>
                          {tsLabel && (
                            <span
                              className="text-[10px] px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap"
                              style={{ backgroundColor: tsColor + '22', color: tsColor, border: `1px solid ${tsColor}55` }}
                              data-testid={`status-${classGroup.id}`}
                            >
                              {tsLabel}
                            </span>
                          )}
                        </div>
                        <CardDescription className="text-xs sm:text-sm">
                          {classGroup.subjects?.length || 0} disciplina(s)
                        </CardDescription>
                      </div>
                    </div>
                  </CardHeader>
                  <CardContent className="p-4 sm:p-6 pt-0">
                    <div className="flex flex-wrap gap-1">
                      {classGroup.subjects?.slice(0, 3).map(s => {
                        const b = subjectStatusMap[`${classGroup.id}__${s.id}`];
                        const dot = b?.cor;
                        return (
                          <Badge key={s.id} variant="outline" className="text-[10px] sm:text-xs flex items-center gap-1">
                            {dot && <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: dot }} />}
                            {s.name}
                          </Badge>
                        );
                      })}
                      {classGroup.subjects?.length > 3 && (
                        <Badge variant="outline" className="text-[10px] sm:text-xs">
                          +{classGroup.subjects.length - 3}
                        </Badge>
                      )}
                    </div>
                  </CardContent>
                </Card>
                );
              })}
            </div>
          )}
        </div>
      ) : !selectedSubject ? (
        // Seleção de Disciplina dentro da Turma
        <div className="space-y-4 sm:space-y-6">
          <div className="flex items-center gap-2 sm:gap-4">
            <Button variant="outline" size="sm" onClick={() => {
              setSelectedClassGroup(null);
              setSelectedSubject(null);
              setSelectedClass(null);
              setStudents([]);
            }} className="px-2 sm:px-3">
              <ArrowLeft className="w-4 h-4 sm:mr-1" />
              <span className="hidden sm:inline">Voltar</span>
            </Button>
            <div className="min-w-0">
              <h2 className="text-base sm:text-lg font-semibold truncate">{selectedClassGroup.name}</h2>
              <p className="text-xs sm:text-sm text-muted-foreground">{students.length} alunos</p>
            </div>
          </div>

          {/* Links Externos - responsivos */}
          <div className="flex flex-wrap gap-2 sm:gap-4">
            <a 
              href="https://login.plurall.net/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-1 sm:gap-2 whitespace-nowrap text-xs sm:text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground h-8 sm:h-9 px-2 sm:px-4 py-2 rounded-md border-orange-200 bg-orange-50/30 hover:bg-orange-100"
            >
              <Globe className="w-3 h-3 sm:w-4 sm:h-4 text-orange-600" />
              Plurall
            </a>
            <a 
              href={selectedClassGroup.google_classroom_link || '#'}
              target="_blank" 
              rel="noopener noreferrer"
              className={`inline-flex items-center justify-center gap-1 sm:gap-2 whitespace-nowrap text-xs sm:text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring h-8 sm:h-9 px-2 sm:px-4 py-2 rounded-md border shadow-sm ${selectedClassGroup.google_classroom_link ? 'border-green-200 bg-green-50/30 hover:bg-green-100' : 'opacity-50 pointer-events-none'}`}
              onClick={(e) => {
                if (!selectedClassGroup.google_classroom_link) {
                  e.preventDefault();
                  toast.info('Link do Google Classroom não configurado para esta turma');
                }
              }}
            >
              <ExternalLink className="w-4 h-4 text-green-600" />
              Google Classroom
            </a>
          </div>

          {/* Seleção de Disciplina */}
          <Card>
            <CardHeader>
              <CardTitle className="text-base">Selecione a Disciplina</CardTitle>
              <CardDescription>Escolha a disciplina para lançar notas, faltas ou conteúdos</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                {classSubjects.map((subject) => (
                  <Card 
                    key={subject.id}
                    className="cursor-pointer hover:border-primary transition-colors border-2"
                    onClick={() => handleSelectSubject(subject)}
                  >
                    <CardContent className="p-4 flex flex-col items-center gap-2 text-center">
                      <div className="p-2 bg-blue-100 rounded-lg">
                        <BookOpen className="w-5 h-5 text-blue-600" />
                      </div>
                      <p className="font-medium text-sm">{subject.name}</p>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </CardContent>
          </Card>

          {/* Lista de Alunos da Turma */}
          <Card>
            <CardHeader>
              <CardTitle className="text-base flex items-center gap-2">
                <Users className="w-5 h-5" />
                Alunos da Turma ({students.length})
              </CardTitle>
            </CardHeader>
            <CardContent className="p-0">
              <div className="max-h-[300px] overflow-y-auto">
                <table className="w-full">
                  <thead className="bg-muted/50 sticky top-0">
                    <tr>
                      <th className="text-left p-3 font-medium">Nº</th>
                      <th className="text-left p-3 font-medium">Nome</th>
                      <th className="text-left p-3 font-medium">Matrícula</th>
                    </tr>
                  </thead>
                  <tbody>
                    {students.map((student, index) => (
                      <tr key={student.id} className="border-t">
                        <td className="p-3">{index + 1}</td>
                        <td className="p-3">
                          <div className="flex items-center gap-3">
                            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-primary to-purple-600 flex items-center justify-center text-white text-sm font-medium">
                              {student.name?.charAt(0).toUpperCase()}
                            </div>
                            <span>{student.name}</span>
                          </div>
                        </td>
                        <td className="p-3 text-muted-foreground">{student.registration_number}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardContent>
          </Card>
        </div>
      ) : (
        // Disciplina Selecionada - Área de trabalho
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button variant="outline" onClick={() => {
                setSelectedSubject(null);
                setSelectedClass(null);
                setGrades([]);
                setLessonContents([]);
              }}>
                ← Voltar
              </Button>
              <div>
                <h2 className="text-lg font-semibold">{selectedClassGroup?.name}</h2>
                <p className="text-muted-foreground flex items-center gap-2">
                  <BookOpen className="w-4 h-4" />
                  {selectedSubject?.name}
                </p>
              </div>
            </div>
            <div className="flex gap-2">
              <a 
                href="https://login.plurall.net/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-1 whitespace-nowrap text-sm font-medium transition-colors h-8 px-3 rounded-md border shadow-sm border-orange-200 bg-orange-50/30 hover:bg-orange-100"
              >
                <Globe className="w-4 h-4 text-orange-600" />
                Plurall
              </a>
              <a 
                href={selectedClassGroup?.google_classroom_link || '#'}
                target="_blank" 
                rel="noopener noreferrer"
                className={`inline-flex items-center justify-center gap-1 whitespace-nowrap text-sm font-medium transition-colors h-8 px-3 rounded-md border shadow-sm ${selectedClassGroup?.google_classroom_link ? 'border-green-200 bg-green-50/30 hover:bg-green-100' : 'opacity-50 pointer-events-none'}`}
                onClick={(e) => {
                  if (!selectedClassGroup?.google_classroom_link) {
                    e.preventDefault();
                    toast.info('Link do Google Classroom não configurado');
                  }
                }}
              >
                <ExternalLink className="w-4 h-4 text-green-600" />
                Classroom
              </a>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
            <Card className="cursor-pointer hover:border-primary transition-colors" onClick={handleOpenGrades}>
              <CardContent className="p-4 flex items-center gap-4">
                <div className="p-3 bg-blue-100 rounded-lg">
                  <PenLine className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <p className="font-medium">Lançar Notas</p>
                  <p className="text-sm text-muted-foreground">Notas e recuperação</p>
                </div>
              </CardContent>
            </Card>
            
            <Card className="cursor-pointer hover:border-primary transition-colors" onClick={handleOpenAttendance}>
              <CardContent className="p-4 flex items-center gap-4">
                <div className="p-3 bg-green-100 rounded-lg">
                  <ClipboardList className="w-6 h-6 text-green-600" />
                </div>
                <div>
                  <p className="font-medium">Fazer Chamada</p>
                  <p className="text-sm text-muted-foreground">Presença dos alunos</p>
                </div>
              </CardContent>
            </Card>
            
            <Card className="cursor-pointer hover:border-primary transition-colors" onClick={() => setContentDialogOpen(true)}>
              <CardContent className="p-4 flex items-center gap-4">
                <div className="p-3 bg-purple-100 rounded-lg">
                  <FileText className="w-6 h-6 text-purple-600" />
                </div>
                <div>
                  <p className="font-medium">Registrar Conteúdo</p>
                  <p className="text-sm text-muted-foreground">Conteúdo ministrado</p>
                </div>
              </CardContent>
            </Card>

            {/* Card de Atividades/Trabalhos */}
            <Card 
              className="cursor-pointer transition-colors hover:border-amber-500 border-amber-200 bg-amber-50/30 relative"
              onClick={() => setAtividadesDialogOpen(true)}
            >
              <CardContent className="p-4 flex items-center gap-4">
                <div className="p-3 bg-amber-100 rounded-lg">
                  <FileUp className="w-6 h-6 text-amber-600" />
                </div>
                <div>
                  <p className="font-medium">Atividades</p>
                  <p className="text-sm text-muted-foreground">Trabalhos e prazos</p>
                </div>
              </CardContent>
              {alertasAtrasados.length > 0 && (
                <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
                  {alertasAtrasados.length}
                </div>
              )}
            </Card>

            <Card 
              className="cursor-pointer transition-colors hover:border-orange-500 border-orange-200 bg-orange-50/30"
              onClick={() => setConsolidarDialogOpen(true)}
            >
              <CardContent className="p-4 flex items-center gap-4">
                <div className="p-3 bg-orange-100 rounded-lg">
                  <Calculator className="w-6 h-6 text-orange-600" />
                </div>
                <div>
                  <p className="font-medium">Calcular Boletim</p>
                  <p className="text-sm text-muted-foreground">Consolidar notas</p>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Alerta de atividades atrasadas */}
          {alertasAtrasados.length > 0 && (
            <Alert className="border-red-200 bg-red-50">
              <AlertTriangle className="h-4 w-4 text-red-600" />
              <AlertDescription>
                <div className="flex justify-between items-center">
                  <span className="font-medium text-red-800">
                    {alertasAtrasados.length} aluno(s) com atividade(s) atrasada(s)
                  </span>
                  <Button 
                    variant="outline" 
                    size="sm"
                    className="border-red-300 hover:bg-red-100"
                    onClick={() => setAlertasDialogOpen(true)}
                  >
                    <Bell className="w-4 h-4 mr-2" />
                    Ver Alertas
                  </Button>
                </div>
              </AlertDescription>
            </Alert>
          )}

          <Tabs defaultValue="students" className="w-full">
            <TabsList>
              <TabsTrigger value="students">Alunos ({students.length})</TabsTrigger>
              <TabsTrigger value="grades">Notas</TabsTrigger>
              <TabsTrigger value="faltas" onClick={() => loadAttendanceRecords()}>
                Faltas
              </TabsTrigger>
              <TabsTrigger value="atividades" className="relative">
                Atividades
                {alertasAtrasados.length > 0 && (
                  <span className="ml-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 inline-flex items-center justify-center">
                    {alertasAtrasados.length}
                  </span>
                )}
              </TabsTrigger>
              <TabsTrigger value="contents">Conteúdos</TabsTrigger>
            </TabsList>

            {/* Students Tab */}
            <TabsContent value="students">
              <Card>
                <CardContent className="p-0">
                  <table className="w-full">
                    <thead className="bg-muted/50">
                      <tr>
                        <th className="text-left p-4 font-medium">Nº</th>
                        <th className="text-left p-4 font-medium">Nome</th>
                        <th className="text-left p-4 font-medium">Matrícula</th>
                      </tr>
                    </thead>
                    <tbody>
                      {students.map((student, index) => (
                        <tr key={student.id} className="border-t">
                          <td className="p-4">{index + 1}</td>
                          <td className="p-4">
                            <div className="flex items-center gap-3">
                              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-primary to-purple-600 flex items-center justify-center text-white text-sm font-medium">
                                {student.name?.charAt(0).toUpperCase()}
                              </div>
                              <span>{student.name}</span>
                            </div>
                          </td>
                          <td className="p-4 text-muted-foreground">{student.registration_number}</td>
                        </tr>
                      ))}
                      {students.length === 0 && (
                        <tr>
                          <td colSpan={3} className="p-8 text-center text-muted-foreground">
                            Nenhum aluno encontrado nesta turma
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </CardContent>
              </Card>
            </TabsContent>

            {/* Grades Tab */}
            <TabsContent value="grades">
              <Card>
                <CardHeader>
                  <div className="flex justify-between items-center flex-wrap gap-2">
                    <CardTitle>Quadro de Notas</CardTitle>
                    <div className="flex gap-2">
                      <Button onClick={handleOpenGrades}>
                        <PenLine className="w-4 h-4 mr-2" />
                        Lançar Notas Parciais
                      </Button>
                      {students.some(s => isInRecovery(s.id)) && (
                        <Button variant="outline" onClick={handleOpenRecovery}>
                          <AlertCircle className="w-4 h-4 mr-2" />
                          Lançar Recuperação
                        </Button>
                      )}
                      {dnaMapaOk && <Button variant="outline" onClick={abrirDnaMapa} data-testid="btn-dna-mapa">DNA Mapa</Button>}
                      <Button variant="outline" onClick={() => setShowFaltantes(true)} data-testid="btn-faltantes-aprovacao">
                        <Target className="w-4 h-4 mr-2" />
                        Notas faltantes para aprovação
                      </Button>
                    </div>
                  </div>
                  <p className="text-sm text-muted-foreground mt-2">
                    Média &lt; 6,0 = Recuperação | Notas arredondadas de 0,5 em 0,5
                  </p>
                </CardHeader>
                <CardContent className="p-0">
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                      <thead className="bg-muted/50">
                        <tr>
                          <th className="text-left p-3 font-medium sticky left-0 bg-muted/50 min-w-[150px]">Aluno</th>
                          {periods.map(period => (
                            <th key={period} colSpan={2} className="text-center p-2 font-medium border-l border-gray-200">
                              <span className="text-xs">{period}</span>
                            </th>
                          ))}
                          <th className="text-center p-2 font-medium bg-green-100 border-l border-gray-200">Final</th>
                          <th className="text-center p-2 font-medium">Status</th>
                          <th className="text-center p-2 font-medium">Boletim</th>
                        </tr>
                        <tr className="bg-muted/30 text-xs">
                          <th className="text-left p-2 font-medium sticky left-0 bg-muted/30"></th>
                          {periods.map(period => (
                            <React.Fragment key={`${period}-sub`}>
                              <th className="text-center p-2 font-medium bg-purple-50 border-l border-gray-200 w-16">Média</th>
                              <th className="text-center p-2 font-medium bg-orange-50 w-16">Rec.</th>
                            </React.Fragment>
                          ))}
                          <th className="text-center p-2 font-medium bg-green-100 border-l border-gray-200 w-16"></th>
                          <th className="text-center p-2 font-medium w-24"></th>
                          <th className="text-center p-2 font-medium w-16"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {students.map((student) => {
                          // Calcular médias e recuperações por trimestre
                          const trimesterData = periods.map(period => ({
                            period,
                            avg: calculateTrimesterAverage(student.id, period),
                            recovery: getRecoveryGrade(student.id, period),
                            finalTri: calculateTrimesterWithRecovery(student.id, period)
                          }));
                          
                          const finalAvg = calculateFinalAverage(student.id);
                          const hasAllGrades = trimesterData.every(t => t.avg !== null);
                          
                          return (
                            <tr key={student.id} className="border-t hover:bg-muted/30">
                              <td className="p-2 sticky left-0 bg-white text-sm">
                                <span className="text-purple-600 font-mono mr-1">{student.call_number || '-'}</span>
                                {student.name}
                              </td>
                              {trimesterData.map(tri => (
                                <React.Fragment key={tri.period}>
                                  <td className={`p-2 text-center border-l border-gray-100 ${tri.avg !== null && tri.avg < 6 ? 'text-red-600 bg-red-50' : 'bg-purple-50/30'}`}>
                                    {tri.avg !== null ? (
                                      <span className="font-medium text-sm">{tri.avg.toFixed(1)}</span>
                                    ) : (
                                      <span className="text-muted-foreground text-xs">-</span>
                                    )}
                                  </td>
                                  <td className="p-2 text-center bg-orange-50/30">
                                    {tri.avg !== null && tri.avg < 6 ? (
                                      tri.recovery !== null ? (
                                        <span className={`font-medium text-sm ${tri.recovery >= 6 ? 'text-green-600' : 'text-orange-600'}`}>
                                          {tri.recovery.toFixed(1)}
                                        </span>
                                      ) : (
                                        <span className="text-orange-500 text-xs">Pend.</span>
                                      )
                                    ) : (
                                      <span className="text-muted-foreground text-xs">-</span>
                                    )}
                                  </td>
                                </React.Fragment>
                              ))}
                              <td className={`p-2 text-center font-bold border-l border-gray-200 ${finalAvg !== null && finalAvg >= 6 ? 'text-green-600 bg-green-100' : finalAvg !== null ? 'text-red-600 bg-red-50' : 'bg-green-50'}`}>
                                {finalAvg !== null ? finalAvg.toFixed(1) : '-'}
                              </td>
                              <td className="p-2 text-center">
                                {!hasAllGrades ? (
                                  <Badge variant="outline" className="text-xs">Sem notas</Badge>
                                ) : finalAvg !== null && finalAvg >= 6 ? (
                                  <Badge className="bg-green-500 text-xs">Aprovado</Badge>
                                ) : trimesterData.some(t => t.avg !== null && t.avg < 6 && t.recovery === null) ? (
                                  <Badge variant="destructive" className="text-xs">Em Rec.</Badge>
                                ) : finalAvg !== null && finalAvg < 6 ? (
                                  <Badge variant="destructive" className="text-xs">Reprovado</Badge>
                                ) : (
                                  <Badge className="bg-green-500 text-xs">Aprovado</Badge>
                                )}
                              </td>
                              <td className="p-2 text-center">
                                <Button
                                  size="sm"
                                  variant="ghost"
                                  onClick={() => window.open(`${window.location.origin}/boletim?student_id=${student.id}`, '_blank')}
                                  title="Ver Boletim"
                                >
                                  <FileText className="w-4 h-4 text-purple-600" />
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  
                  {/* Legenda */}
                  <div className="p-4 border-t bg-muted/30 flex flex-wrap gap-4 text-sm">
                    <div className="flex items-center gap-2">
                      <div className="w-4 h-4 bg-blue-50 border rounded"></div>
                      <span>Média dos Bimestres</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="w-4 h-4 bg-amber-50 border rounded"></div>
                      <span>Nota de Recuperação</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="w-4 h-4 bg-green-50 border rounded"></div>
                      <span>Nota Final</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Badge className="bg-green-500">Aprovado</Badge>
                      <span>≥ 6,0</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Badge variant="destructive">Em Recuperação</Badge>
                      <span>&lt; 6,0</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </TabsContent>

            {/* Faltas Tab */}
            <TabsContent value="faltas">
              <Card>
                <CardHeader>
                  <div className="flex justify-between items-center flex-wrap gap-2">
                    <div>
                      <CardTitle>Registro de Faltas</CardTitle>
                      <p className="text-sm text-muted-foreground mt-1">
                        Visualize e edite as faltas dos alunos
                      </p>
                    </div>
                    <Button onClick={handleOpenAttendance}>
                      <CheckCircle className="w-4 h-4 mr-2" />
                      Fazer Chamada
                    </Button>
                  </div>
                </CardHeader>
                <CardContent>
                  {loadingAttendance ? (
                    <div className="flex items-center justify-center p-8">
                      <Loader2 className="w-8 h-8 animate-spin text-primary" />
                    </div>
                  ) : attendanceRecords.length === 0 ? (
                    <div className="text-center p-8 text-muted-foreground">
                      <ClipboardList className="w-12 h-12 mx-auto mb-4 opacity-50" />
                      <p>Nenhum registro de chamada</p>
                      <p className="text-sm mt-1">Clique em "Fazer Chamada" para registrar</p>
                    </div>
                  ) : (
                    <div className="space-y-4">
                      {/* Resumo */}
                      <div className="flex gap-4 flex-wrap text-sm">
                        <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
                          <CheckCircle className="w-3 h-3 mr-1" />
                          Presenças: {attendanceRecords.filter(r => r.present).length}
                        </Badge>
                        <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200">
                          <XCircle className="w-3 h-3 mr-1" />
                          Faltas: {attendanceRecords.filter(r => !r.present).length}
                        </Badge>
                      </div>
                      
                      {/* Tabela de faltas */}
                      <div className="overflow-x-auto">
                        <table className="w-full text-sm">
                          <thead className="bg-muted/50">
                            <tr>
                              <th className="text-left p-3 font-medium">Data</th>
                              <th className="text-left p-3 font-medium">Aluno</th>
                              <th className="text-center p-3 font-medium">Status</th>
                              <th className="text-center p-3 font-medium">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {attendanceRecords
                              .filter(r => !r.present) // Mostrar apenas faltas
                              .sort((a, b) => new Date(b.date) - new Date(a.date))
                              .map(record => (
                                <tr key={record.id} className="border-t hover:bg-muted/30">
                                  <td className="p-3">
                                    {new Date(record.date + 'T12:00:00').toLocaleDateString('pt-BR')}
                                  </td>
                                  <td className="p-3">{record.student_name || 'Aluno'}</td>
                                  <td className="p-3 text-center">
                                    <Badge variant={record.present ? "default" : "destructive"}>
                                      {record.present ? 'Presente' : (record.justified ? 'Falta Justificada' : 'Falta')}
                                    </Badge>
                                  </td>
                                  <td className="p-3 text-center">
                                    <div className="flex justify-center gap-2">
                                      <Button 
                                        size="sm" 
                                        variant="outline"
                                        onClick={() => handleUpdateAttendance(record, true)}
                                        title="Marcar como presente"
                                      >
                                        <CheckCircle className="w-4 h-4 text-green-600" />
                                      </Button>
                                      <Button 
                                        size="sm" 
                                        variant="outline"
                                        onClick={() => handleDeleteAttendance(record.id)}
                                        title="Excluir registro"
                                      >
                                        <Trash2 className="w-4 h-4 text-red-600" />
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            {attendanceRecords.filter(r => !r.present).length === 0 && (
                              <tr>
                                <td colSpan={4} className="p-8 text-center text-muted-foreground">
                                  <CheckCircle className="w-12 h-12 mx-auto mb-4 opacity-50 text-green-500" />
                                  <p>Nenhuma falta registrada!</p>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </CardContent>
              </Card>
            </TabsContent>

            {/* Contents Tab */}
            <TabsContent value="contents">
              <Card>
                <CardHeader>
                  <div className="flex justify-between items-center">
                    <CardTitle>Conteúdos Registrados</CardTitle>
                    <Button onClick={() => setContentDialogOpen(true)}>
                      <FileText className="w-4 h-4 mr-2" />
                      Novo Conteúdo
                    </Button>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="space-y-4">
                    {lessonContents.map((content) => (
                      <div key={content.id} className="p-4 border rounded-lg">
                        <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
                          <Calendar className="w-4 h-4" />
                          {new Date(content.date + 'T12:00:00').toLocaleDateString('pt-BR')}
                        </div>
                        <p className="font-medium">{content.content}</p>
                        {content.homework && (
                          <div className="mt-2 p-2 bg-amber-50 rounded text-sm">
                            <span className="font-medium">Tarefa: </span>
                            {content.homework}
                          </div>
                        )}
                        {content.observations && (
                          <p className="mt-2 text-sm text-muted-foreground">
                            <span className="font-medium">Obs: </span>
                            {content.observations}
                          </p>
                        )}
                      </div>
                    ))}
                    {lessonContents.length === 0 && (
                      <div className="text-center p-8 text-muted-foreground">
                        <FileText className="w-12 h-12 mx-auto mb-4 opacity-50" />
                        <p>Nenhum conteúdo registrado ainda</p>
                      </div>
                    )}
                  </div>
                </CardContent>
              </Card>
            </TabsContent>

            {/* Atividades Tab */}
            <TabsContent value="atividades">
              <Card>
                <CardHeader>
                  <div className="flex justify-between items-center flex-wrap gap-2">
                    <div>
                      <CardTitle>Atividades e Trabalhos</CardTitle>
                      <CardDescription>Gerencie atividades com prazos de entrega</CardDescription>
                    </div>
                    <Button onClick={() => setAtividadesDialogOpen(true)}>
                      <Plus className="w-4 h-4 mr-2" />
                      Nova Atividade
                    </Button>
                  </div>
                </CardHeader>
                <CardContent>
                  {atividades.length > 0 ? (
                    <div className="space-y-3">
                      {atividades.map(ativ => {
                        const isVencido = ativ.estatisticas?.vencido;
                        const totalEntregues = ativ.estatisticas?.entregues || 0;
                        const totalAlunos = ativ.estatisticas?.total || 0;
                        const pendentes = ativ.estatisticas?.pendentes || 0;
                        const atrasados = ativ.estatisticas?.atrasados || 0;
                        
                        return (
                          <div 
                            key={ativ.id} 
                            className={`p-4 border rounded-lg cursor-pointer hover:bg-muted/30 transition-colors ${
                              isVencido && atrasados > 0 ? 'border-red-200 bg-red-50/30' : ''
                            }`}
                            onClick={() => handleVerAtividade(ativ)}
                          >
                            <div className="flex justify-between items-start gap-4">
                              <div className="flex-1">
                                <h4 className="font-medium flex items-center gap-2">
                                  {ativ.titulo}
                                  {isVencido && atrasados > 0 && (
                                    <Badge variant="destructive" className="text-xs">
                                      {atrasados} atrasado(s)
                                    </Badge>
                                  )}
                                </h4>
                                {ativ.descricao && (
                                  <p className="text-sm text-muted-foreground mt-1">{ativ.descricao}</p>
                                )}
                                <div className="flex items-center gap-4 mt-2 text-sm">
                                  <span className="flex items-center gap-1 text-muted-foreground">
                                    <Calendar className="w-4 h-4" />
                                    Entrega: {new Date(ativ.data_entrega + 'T12:00:00').toLocaleDateString('pt-BR')}
                                  </span>
                                  <span className="text-muted-foreground">
                                    Pontuação: {ativ.pontuacao_maxima} pts
                                  </span>
                                </div>
                              </div>
                              <div className="text-right">
                                <div className="text-2xl font-bold text-primary">
                                  {totalEntregues}/{totalAlunos}
                                </div>
                                <div className="text-xs text-muted-foreground">entregas</div>
                              </div>
                            </div>
                            
                            {/* Progress bar */}
                            <div className="mt-3 h-2 bg-muted rounded-full overflow-hidden">
                              <div 
                                className="h-full bg-green-500 transition-all"
                                style={{ width: `${totalAlunos > 0 ? (totalEntregues / totalAlunos) * 100 : 0}%` }}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="text-center p-8 text-muted-foreground">
                      <FileUp className="w-12 h-12 mx-auto mb-4 opacity-50" />
                      <p>Nenhuma atividade criada ainda</p>
                      <Button 
                        variant="outline" 
                        className="mt-4"
                        onClick={() => setAtividadesDialogOpen(true)}
                      >
                        <Plus className="w-4 h-4 mr-2" />
                        Criar Primeira Atividade
                      </Button>
                    </div>
                  )}
                </CardContent>
              </Card>
            </TabsContent>
          </Tabs>
        </div>
      )}

      {/* Grades Dialog - Lançamento por Turma */}
      <Dialog open={gradesDialogOpen} onOpenChange={setGradesDialogOpen}>
        <DialogContent className="w-[95vw] max-w-6xl max-h-[90vh] overflow-y-auto p-3 sm:p-6">
          <DialogHeader>
            <DialogTitle className="text-base sm:text-lg">Lançar Notas - {gradeForm.period}</DialogTitle>
          </DialogHeader>
          
          <div className="space-y-3 sm:space-y-4">
            <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
              <div className="space-y-2">
                <Label className="text-sm">Trimestre</Label>
                <Select 
                  value={gradeForm.period} 
                  onValueChange={(v) => {
                    setGradeForm({ ...gradeForm, period: v });
                    // Reload grades for new period
                    loadGradesForPeriod(v);
                  }}
                >
                  <SelectTrigger className="w-full sm:w-[180px]">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {periods.map(p => (
                      <SelectItem key={p} value={p}>{p}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <div className="flex-1 p-2 sm:p-3 bg-blue-50 border border-blue-200 rounded-lg text-xs sm:text-sm text-blue-700">
                <strong>Dica:</strong> <span className="hidden sm:inline">Lance as 4 notas (APA, Prontidão, Trabalho, Avaliação Trimestral) para calcular a média trimestral automaticamente.</span>
                <span className="sm:hidden">Lance as 4 notas para calcular a média.</span>
              </div>
            </div>

            <div className="border rounded-lg overflow-x-auto -mx-3 sm:mx-0">
              <table className="w-full text-xs sm:text-sm min-w-[700px]">
                <thead className="bg-muted/50">
                  <tr>
                    <th className="text-left p-1.5 sm:p-2 font-medium sticky left-0 bg-muted/50 min-w-[120px] sm:min-w-[180px]">Aluno</th>
                    <th className="text-center p-1.5 sm:p-2 font-medium w-14 sm:w-20">APA</th>
                    <th className="text-center p-1.5 sm:p-2 font-medium w-14 sm:w-20"><span className="hidden sm:inline">Prontidão</span><span className="sm:hidden">Pront.</span></th>
                    <th className="text-center p-1.5 sm:p-2 font-medium w-14 sm:w-20"><span className="hidden sm:inline">Trabalho</span><span className="sm:hidden">Trab.</span></th>
                    <th className="text-center p-1.5 sm:p-2 font-medium w-14 sm:w-24"><span className="hidden sm:inline">Av. Trimestral</span><span className="sm:hidden">Av.Trim</span></th>
                    <th className="text-center p-1.5 sm:p-2 font-medium w-14 sm:w-20 bg-purple-100"><span className="hidden sm:inline">Média Trim.</span><span className="sm:hidden">M.Trim</span></th>
                    <th className="text-center p-1.5 sm:p-2 font-medium w-14 sm:w-20 bg-orange-100"><span className="hidden sm:inline">Recuperação</span><span className="sm:hidden">Rec.</span></th>
                    <th className="text-center p-1.5 sm:p-2 font-medium w-14 sm:w-20 bg-green-100"><span className="hidden sm:inline">Média Final</span><span className="sm:hidden">M.Final</span></th>
                    <th className="text-center p-1.5 sm:p-2 font-medium w-16 sm:w-20">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {students.map((student) => {
                    // Usar a média do formulário se disponível, senão usar a média salva
                    const formTrimesterAvg = calculateFormTrimesterAverage(student.id);
                    const savedTrimesterAvg = calculateTrimesterAverage(student.id, gradeForm.period);
                    const trimesterAvg = formTrimesterAvg !== null ? formTrimesterAvg : savedTrimesterAvg;
                    
                    // Usar recuperação do formulário se disponível, senão usar a salva
                    const formRecoveryGrade = getFormRecoveryGrade(student.id);
                    const savedRecoveryGrade = getRecoveryGrade(student.id, gradeForm.period);
                    const recoveryGrade = formRecoveryGrade !== null ? formRecoveryGrade : savedRecoveryGrade;
                    
                    const finalAvg = calculateFinalAverage(student.id);
                    const status = finalAvg !== null ? (finalAvg >= 6.0 ? 'approved' : 'recovery') : 'pending';
                    
                    return (
                      <tr key={student.id} className="border-t hover:bg-muted/30">
                        <td className="p-1.5 sm:p-2 font-medium sticky left-0 bg-background text-xs sm:text-sm truncate max-w-[120px] sm:max-w-none">
                          <span className="text-purple-600 font-mono mr-1">{student.call_number || '-'}</span>
                          {student.name}
                          <button type="button" onClick={() => handleClearTrimester(student)}
                            data-testid={`clear-trimester-${student.id}`}
                            title="Limpar notas deste trimestre (auditado)"
                            className="ml-1.5 align-middle text-muted-foreground hover:text-red-600 transition-colors">
                            <Eraser className="w-3.5 h-3.5 inline" />
                          </button>
                        </td>
                        {evaluationTypes.map(evalType => (
                          <td key={evalType.value} className="p-0.5 sm:p-1">
                            <Input
                              type="number"
                              min="0"
                              max="10"
                              step="0.5"
                              value={studentGrades[`${student.id}_${evalType.value}`] || ''}
                              onChange={(e) => handleGradeChange(student.id, evalType.value, e.target.value)}
                              className="w-12 sm:w-16 text-center mx-auto h-7 sm:h-8 text-xs sm:text-sm"
                              placeholder="-"
                            />
                          </td>
                        ))}
                        <td className="p-1.5 sm:p-2 text-center bg-purple-50">
                          {trimesterAvg !== null ? (
                            <span className={`font-bold text-xs sm:text-sm ${trimesterAvg >= 6 ? 'text-green-600' : 'text-red-600'}`}>
                              {trimesterAvg.toFixed(1)}
                            </span>
                          ) : (
                            <span className="text-muted-foreground">-</span>
                          )}
                        </td>
                        <td className="p-0.5 sm:p-1 text-center bg-orange-50">
                          {trimesterAvg !== null && trimesterAvg < 6 ? (
                            <Input
                              type="number"
                              min="0"
                              max="10"
                              step="0.5"
                              value={studentGrades[`${student.id}_Recuperação`] || (recoveryGrade !== null ? recoveryGrade : '')}
                              onChange={(e) => handleGradeChange(student.id, 'Recuperação', e.target.value)}
                              className="w-12 sm:w-16 text-center mx-auto h-7 sm:h-8 text-xs sm:text-sm bg-orange-100 border-orange-300"
                              placeholder="-"
                            />
                          ) : recoveryGrade !== null ? (
                            <span className={`font-bold text-xs sm:text-sm ${recoveryGrade >= 6 ? 'text-green-600' : 'text-orange-600'}`}>
                              {recoveryGrade.toFixed(1)}
                            </span>
                          ) : (
                            <span className="text-muted-foreground text-xs">-</span>
                          )}
                        </td>
                        <td className="p-1.5 sm:p-2 text-center bg-green-50">
                          {finalAvg !== null ? (
                            <span className={`font-bold text-xs sm:text-sm ${finalAvg >= 6 ? 'text-green-600' : 'text-red-600'}`}>
                              {finalAvg.toFixed(1)}
                            </span>
                          ) : (
                            <span className="text-muted-foreground">-</span>
                          )}
                        </td>
                        <td className="p-1.5 sm:p-2 text-center">
                          {status === 'approved' && (
                            <Badge className="bg-green-500 text-[10px] sm:text-xs px-1 sm:px-2">
                              <span className="hidden sm:inline">Aprovado</span>
                              <span className="sm:hidden">OK</span>
                            </Badge>
                          )}
                          {status === 'recovery' && (
                            <Badge variant="destructive" className="text-[10px] sm:text-xs px-1 sm:px-2">
                              <span className="hidden sm:inline">Recuperação</span>
                              <span className="sm:hidden">Rec</span>
                            </Badge>
                          )}
                          {status === 'pending' && (
                            <Badge variant="outline">Pendente</Badge>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <p className="text-xs text-muted-foreground">
              * Média Trimestral = (APA + Prontidão + Trabalho + Av. Trimestral) / 4 | 
              * Recuperação substitui média trimestral se for maior (máx. 6,0) | 
              * Média Final = (1º Tri + 2º Tri + 3º Tri) / 3 | 
              * Média mínima para aprovação: 6,0
            </p>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setGradesDialogOpen(false)}>
              Cancelar
            </Button>
            <Button onClick={handleSaveAllGrades}>
              <Save className="w-4 h-4 mr-2" />
              Salvar Todas as Notas
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Attendance Dialog */}
      <Dialog open={attendanceDialogOpen} onOpenChange={setAttendanceDialogOpen}>
        <DialogContent className="w-[95vw] max-w-2xl max-h-[90vh] overflow-y-auto p-3 sm:p-6">
          <DialogHeader>
            <DialogTitle className="text-base sm:text-lg">Fazer Chamada</DialogTitle>
          </DialogHeader>
          
          <div className="space-y-3 sm:space-y-4">
            <div className="space-y-2">
              <Label className="text-sm">Data</Label>
              <Input
                type="date"
                value={attendanceDate}
                onChange={(e) => setAttendanceDate(e.target.value)}
                className="w-full"
              />
            </div>

            <div className="border rounded-lg overflow-hidden -mx-3 sm:mx-0">
              <table className="w-full text-sm">
                <thead className="bg-muted/50">
                  <tr>
                    <th className="text-left p-2 sm:p-3 font-medium w-10">Nº</th>
                    <th className="text-left p-2 sm:p-3 font-medium">Aluno</th>
                    <th className="text-center p-2 sm:p-3 font-medium w-20 sm:w-32">Presente</th>
                  </tr>
                </thead>
                <tbody>
                  {students.map((student, index) => (
                    <tr key={student.id} className="border-t">
                      <td className="p-2 sm:p-3 text-xs sm:text-sm font-mono text-purple-600">{student.call_number || '-'}</td>
                      <td className="p-2 sm:p-3 text-xs sm:text-sm truncate max-w-[150px] sm:max-w-none">{student.name}</td>
                      <td className="p-2 sm:p-3 text-center">
                        <div className="flex justify-center">
                          <Checkbox
                            checked={attendance[student.id] !== false}
                            onCheckedChange={(checked) => setAttendance({
                              ...attendance,
                              [student.id]: checked
                            })}
                            className="h-5 w-5 sm:h-4 sm:w-4"
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="flex justify-between text-xs sm:text-sm bg-muted/30 p-2 sm:p-3 rounded-lg">
              <span className="flex items-center gap-1 sm:gap-2">
                <CheckCircle className="w-4 h-4 text-green-500" />
                Presentes: {Object.values(attendance).filter(v => v !== false).length}
              </span>
              <span className="flex items-center gap-1 sm:gap-2">
                <XCircle className="w-4 h-4 text-red-500" />
                Faltas: {Object.values(attendance).filter(v => v === false).length}
              </span>
            </div>
          </div>

          <DialogFooter className="flex-col sm:flex-row gap-2 sm:gap-0">
            <Button variant="outline" onClick={() => setAttendanceDialogOpen(false)} className="w-full sm:w-auto">
              Cancelar
            </Button>
            <Button onClick={handleSaveAttendance} className="w-full sm:w-auto">
              <Save className="w-4 h-4 mr-2" />
              Salvar Chamada
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Recovery Dialog */}
      <Dialog open={recoveryDialogOpen} onOpenChange={setRecoveryDialogOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Lançar Notas de Recuperação</DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">
              Alunos com média abaixo de 6,0. A nota final após recuperação será no máximo 6,0.
            </p>

            <div className="border rounded-lg overflow-hidden">
              <table className="w-full">
                <thead className="bg-muted/50">
                  <tr>
                    <th className="text-left p-3 font-medium">Aluno</th>
                    <th className="text-center p-3 font-medium">Média</th>
                    <th className="text-center p-3 font-medium w-32">Recuperação</th>
                  </tr>
                </thead>
                <tbody>
                  {students.filter(s => isInRecovery(s.id)).map((student) => (
                    <tr key={student.id} className="border-t">
                      <td className="p-3">
                        <span className="text-purple-600 font-mono mr-1">{student.call_number || '-'}</span>
                        {student.name}
                      </td>
                      <td className="p-3 text-center text-red-600 font-medium">
                        {calculateFinalGrade(student.id)?.toFixed(1)}
                      </td>
                      <td className="p-3">
                        <Input
                          type="number"
                          min="0"
                          max="10"
                          step="0.5"
                          value={recoveryGrades[student.id] || ''}
                          onChange={(e) => setRecoveryGrades({
                            ...recoveryGrades,
                            [student.id]: e.target.value
                          })}
                          className="w-24 text-center mx-auto"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {students.filter(s => isInRecovery(s.id)).length === 0 && (
              <p className="text-center text-muted-foreground py-4">
                Nenhum aluno em recuperação.
              </p>
            )}
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setRecoveryDialogOpen(false)}>
              Cancelar
            </Button>
            <Button onClick={handleSaveRecovery}>
              <Save className="w-4 h-4 mr-2" />
              Salvar Recuperação
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Content Dialog */}
      <Dialog open={contentDialogOpen} onOpenChange={setContentDialogOpen}>
        <DialogContent className="w-[95vw] max-w-lg p-3 sm:p-6">
          <DialogHeader>
            <DialogTitle className="text-base sm:text-lg">Registrar Conteúdo</DialogTitle>
          </DialogHeader>
          
          <div className="space-y-3 sm:space-y-4">
            <div className="space-y-2">
              <Label className="text-sm">Data</Label>
              <Input
                type="date"
                value={contentForm.date}
                onChange={(e) => setContentForm({ ...contentForm, date: e.target.value })}
                className="w-full"
              />
            </div>

            <div className="space-y-2">
              <Label className="text-sm">Conteúdo Ministrado *</Label>
              <Textarea
                rows={3}
                value={contentForm.content}
                onChange={(e) => setContentForm({ ...contentForm, content: e.target.value })}
                placeholder="Descreva o conteúdo abordado na aula..."
                className="text-sm"
              />
            </div>

            <div className="space-y-2">
              <Label className="text-sm">Tarefa de Casa</Label>
              <Textarea
                rows={2}
                value={contentForm.homework}
                onChange={(e) => setContentForm({ ...contentForm, homework: e.target.value })}
                placeholder="Tarefa passada para os alunos (opcional)"
              />
            </div>

            <div className="space-y-2">
              <Label>Observações</Label>
              <Textarea
                rows={2}
                value={contentForm.observations}
                onChange={(e) => setContentForm({ ...contentForm, observations: e.target.value })}
                placeholder="Observações adicionais (opcional)"
              />
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setContentDialogOpen(false)}>
              Cancelar
            </Button>
            <Button onClick={handleSaveContent}>
              <Save className="w-4 h-4 mr-2" />
              Salvar Conteúdo
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Clock In Dialog */}
      <Dialog open={clockDialogOpen} onOpenChange={(open) => { 
        setClockDialogOpen(open); 
        if (!open) {
          setLocation(null);
          setLocationError('');
        }
      }}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle>Bater Ponto</DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4">
            <div className="space-y-2">
              <Label>Tipo de Registro</Label>
              <Select value={clockType} onValueChange={setClockType}>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="entrada">
                    <div className="flex items-center gap-2">
                      <LogIn className="w-4 h-4 text-green-500" />
                      Entrada
                    </div>
                  </SelectItem>
                  <SelectItem value="saida_almoco">
                    <div className="flex items-center gap-2">
                      <Coffee className="w-4 h-4 text-amber-500" />
                      Saída Almoço
                    </div>
                  </SelectItem>
                  <SelectItem value="retorno_almoco">
                    <div className="flex items-center gap-2">
                      <Coffee className="w-4 h-4 text-blue-500" />
                      Retorno Almoço
                    </div>
                  </SelectItem>
                  <SelectItem value="saida">
                    <div className="flex items-center gap-2">
                      <LogOut className="w-4 h-4 text-red-500" />
                      Saída
                    </div>
                  </SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label>Localização GPS</Label>
              <div className="border rounded-lg p-4 bg-muted/30">
                {location ? (
                  <div className="space-y-3">
                    {distanciaEscola !== null && distanciaEscola <= 30 ? (
                      <div className="flex items-center gap-2 text-green-600">
                        <CheckCircle className="w-5 h-5" />
                        <span className="font-medium">Localização válida!</span>
                      </div>
                    ) : distanciaEscola !== null ? (
                      <div className="flex items-center gap-2 text-red-600">
                        <XCircle className="w-5 h-5" />
                        <span className="font-medium">Fora da área permitida</span>
                      </div>
                    ) : (
                      <div className="flex items-center gap-2 text-green-600">
                        <CheckCircle className="w-5 h-5" />
                        <span className="font-medium">Localização capturada!</span>
                      </div>
                    )}
                    
                    {distanciaEscola !== null && (
                      <div className={`p-2 rounded-lg text-sm ${
                        distanciaEscola <= 30 
                          ? 'bg-green-50 text-green-700' 
                          : 'bg-red-50 text-red-700'
                      }`}>
                        <MapPin className="w-4 h-4 inline mr-1" />
                        Distância da escola: <strong>{distanciaEscola}m</strong>
                        {distanciaEscola > 30 && (
                          <span> (máximo permitido: 30m)</span>
                        )}
                      </div>
                    )}
                    
                    {location.accuracy && (
                      <p className="text-xs text-muted-foreground">
                        Precisão GPS: ~{Math.round(location.accuracy)} metros
                      </p>
                    )}
                  </div>
                ) : (
                  <div className="text-center py-4">
                    {gettingLocation ? (
                      <div className="flex flex-col items-center gap-2">
                        <Loader2 className="w-8 h-8 animate-spin text-primary" />
                        <p className="text-sm text-muted-foreground">Obtendo localização...</p>
                      </div>
                    ) : (
                      <div className="flex flex-col items-center gap-2">
                        <MapPin className="w-12 h-12 text-muted-foreground/50" />
                        <p className="text-sm text-muted-foreground">Clique para capturar sua localização</p>
                      </div>
                    )}
                  </div>
                )}
                
                {locationError && (
                  <div className="mt-2 p-2 bg-red-50 border border-red-200 rounded text-red-600 text-sm flex items-center gap-2">
                    <AlertCircle className="w-4 h-4" />
                    {locationError}
                  </div>
                )}
              </div>
              
              <div className="flex gap-2">
                {!location && (
                  <Button 
                    type="button" 
                    onClick={getLocation} 
                    className="flex-1"
                    disabled={gettingLocation}
                  >
                    {gettingLocation ? (
                      <>
                        <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                        Capturando...
                      </>
                    ) : (
                      <>
                        <MapPin className="w-4 h-4 mr-2" />
                        Capturar Localização
                      </>
                    )}
                  </Button>
                )}
                {location && (
                  <Button 
                    type="button" 
                    variant="outline" 
                    onClick={() => { setLocation(null); getLocation(); }}
                    className="flex-1"
                  >
                    <MapPin className="w-4 h-4 mr-2" />
                    Atualizar Localização
                  </Button>
                )}
              </div>
            </div>

            <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
              <div className="flex items-center gap-2 text-blue-700 text-sm">
                <Clock className="w-4 h-4" />
                <span>
                  Horário atual: <strong>{new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}</strong>
                </span>
              </div>
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setClockDialogOpen(false)}>
              Cancelar
            </Button>
            <Button 
              onClick={handleClockIn} 
              disabled={!location || (distanciaEscola !== null && distanciaEscola > 30)}
            >
              <CheckCircle className="w-4 h-4 mr-2" />
              Registrar Ponto
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Consolidar Boletim */}
      <Dialog open={consolidarDialogOpen} onOpenChange={setConsolidarDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Calculator className="w-5 h-5 text-orange-600" />
              Calcular Boletim
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4">
            <div className="p-4 bg-orange-50 rounded-lg border border-orange-200">
              <p className="text-sm text-orange-800">
                <strong>Turma:</strong> {selectedClassGroup?.name}
              </p>
              <p className="text-sm text-orange-800">
                <strong>Disciplina:</strong> {selectedSubject?.name}
              </p>
            </div>
            
            <div>
              <label className="block text-sm font-medium mb-2">Selecione o Trimestre:</label>
              <div className="grid grid-cols-3 gap-2">
                {['1º Trimestre', '2º Trimestre', '3º Trimestre'].map(tri => (
                  <Button
                    key={tri}
                    variant={trimestreConsolidar === tri ? 'default' : 'outline'}
                    onClick={() => setTrimestreConsolidar(tri)}
                    className={trimestreConsolidar === tri ? 'bg-orange-600 hover:bg-orange-700' : ''}
                  >
                    {tri.replace(' Trimestre', 'º Tri')}
                  </Button>
                ))}
              </div>
            </div>
            
            <div className="p-3 bg-muted rounded-lg text-sm">
              <p><strong>Datas do {trimestreConsolidar}:</strong></p>
              {trimestreConsolidar === '1º Trimestre' && <p>28/01/2026 a 08/05/2026 (67 dias letivos)</p>}
              {trimestreConsolidar === '2º Trimestre' && <p>11/05/2026 a 28/08/2026 (61 dias letivos)</p>}
              {trimestreConsolidar === '3º Trimestre' && <p>31/08/2026 a 17/12/2026 (72 dias letivos)</p>}
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setConsolidarDialogOpen(false)}>
              Cancelar
            </Button>
            <Button 
              variant="outline"
              onClick={() => {
                // Abrir página de boletim em nova aba
                const baseUrl = window.location.origin;
                window.open(`${baseUrl}/boletim`, '_blank');
              }}
            >
              <FileText className="w-4 h-4 mr-2" />
              Ver Boletins
            </Button>
            <Button 
              onClick={handleConsolidarBoletim} 
              disabled={consolidating}
              className="bg-orange-600 hover:bg-orange-700"
            >
              {consolidating ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Processando...
                </>
              ) : (
                <>
                  <Calculator className="w-4 h-4 mr-2" />
                  Consolidar {trimestreConsolidar.replace(' Trimestre', 'º Tri')}
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Calendário DNA - Upload */}
      <Dialog open={calendarioDialogOpen} onOpenChange={setCalendarioDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <CalendarDays className="w-5 h-5 text-purple-600" />
              Calendário DNA {new Date().getFullYear()}
            </DialogTitle>
            <DialogDescription>
              Envie o calendário escolar anual (PDF ou imagem)
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <div className="border-2 border-dashed border-border rounded-lg p-6 text-center hover:border-purple-500/50 transition-colors">
              <Input
                id="calendario-file-input"
                type="file"
                accept=".pdf,.png,.jpg,.jpeg"
                onChange={(e) => setCalendarioFile(e.target.files[0])}
                className="hidden"
              />
              <label htmlFor="calendario-file-input" className="cursor-pointer">
                <Upload className="w-10 h-10 mx-auto text-muted-foreground mb-2" />
                <p className="text-sm font-medium">
                  {calendarioFile ? calendarioFile.name : 'Clique para selecionar arquivo'}
                </p>
                <p className="text-xs text-muted-foreground mt-1">
                  PDF, PNG ou JPG
                </p>
              </label>
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setCalendarioDialogOpen(false)}>
              Cancelar
            </Button>
            <Button 
              onClick={handleUploadCalendario} 
              disabled={!calendarioFile || uploadingCalendario}
              className="bg-purple-600 hover:bg-purple-700"
            >
              {uploadingCalendario ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Enviando...
                </>
              ) : (
                <>
                  <Upload className="w-4 h-4 mr-2" />
                  Enviar Calendário
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Calendário DNA - Visualização */}
      <Dialog open={viewCalendarioDialogOpen} onOpenChange={setViewCalendarioDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <CalendarDays className="w-5 h-5 text-purple-600" />
              Calendário DNA {calendarioDisponivel?.ano}
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4">
            <div className="p-4 bg-purple-50 rounded-lg border border-purple-200">
              <div className="flex items-center gap-3">
                <div className="p-3 bg-purple-100 rounded-lg">
                  <FileText className="w-8 h-8 text-purple-600" />
                </div>
                <div>
                  <p className="font-medium">{calendarioDisponivel?.filename}</p>
                  <p className="text-sm text-muted-foreground">
                    Enviado em {calendarioDisponivel?.uploaded_at ? 
                      new Date(calendarioDisponivel.uploaded_at).toLocaleDateString('pt-BR') : '-'}
                  </p>
                </div>
              </div>
            </div>
            
            <div className="flex gap-2">
              <Button 
                className="flex-1 bg-purple-600 hover:bg-purple-700"
                onClick={handleDownloadCalendario}
              >
                <Download className="w-4 h-4 mr-2" />
                Baixar Calendário
              </Button>
              {user?.role === 'admin' && (
                <Button 
                  variant="outline"
                  onClick={() => {
                    setViewCalendarioDialogOpen(false);
                    setCalendarioDialogOpen(true);
                  }}
                >
                  <Upload className="w-4 h-4 mr-2" />
                  Atualizar
                </Button>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Nova Atividade */}
      <Dialog open={atividadesDialogOpen} onOpenChange={setAtividadesDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileUp className="w-5 h-5 text-amber-600" />
              Nova Atividade
            </DialogTitle>
            <DialogDescription>
              Crie uma atividade ou trabalho com prazo de entrega
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <div className="space-y-2">
              <Label>Título *</Label>
              <Input
                placeholder="Ex: Trabalho de Pesquisa"
                value={atividadeForm.titulo}
                onChange={(e) => setAtividadeForm({ ...atividadeForm, titulo: e.target.value })}
              />
            </div>
            
            <div className="space-y-2">
              <Label>Descrição</Label>
              <Textarea
                placeholder="Descreva a atividade..."
                value={atividadeForm.descricao}
                onChange={(e) => setAtividadeForm({ ...atividadeForm, descricao: e.target.value })}
                rows={3}
              />
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Data de Entrega *</Label>
                <Input
                  type="date"
                  value={atividadeForm.data_entrega}
                  onChange={(e) => setAtividadeForm({ ...atividadeForm, data_entrega: e.target.value })}
                  min={new Date().toISOString().split('T')[0]}
                />
              </div>
              
              <div className="space-y-2">
                <Label>Pontuação Máxima</Label>
                <Input
                  type="number"
                  min="1"
                  max="100"
                  value={atividadeForm.pontuacao_maxima}
                  onChange={(e) => setAtividadeForm({ ...atividadeForm, pontuacao_maxima: parseFloat(e.target.value) || 10 })}
                />
              </div>
            </div>
            
            <div className="space-y-2">
              <Label>Trimestre</Label>
              <Select 
                value={atividadeForm.trimestre} 
                onValueChange={(v) => setAtividadeForm({ ...atividadeForm, trimestre: v })}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {periods.map(p => (
                    <SelectItem key={p} value={p}>{p}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setAtividadesDialogOpen(false)}>
              Cancelar
            </Button>
            <Button 
              onClick={handleCreateAtividade} 
              disabled={creatingAtividade}
              className="bg-amber-600 hover:bg-amber-700"
            >
              {creatingAtividade ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Criando...
                </>
              ) : (
                <>
                  <Plus className="w-4 h-4 mr-2" />
                  Criar Atividade
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Detalhes da Atividade */}
      <Dialog open={atividadeDetalheDialogOpen} onOpenChange={setAtividadeDetalheDialogOpen}>
        <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center justify-between">
              <span className="flex items-center gap-2">
                <FileUp className="w-5 h-5 text-amber-600" />
                {atividadeDetalhe?.titulo}
              </span>
              <div className="flex gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => {
                    setNovoPrazo(atividadeDetalhe?.data_entrega || '');
                    setAlunoSelecionadoPrazo(null);
                    setAlterarPrazoDialogOpen(true);
                  }}
                  disabled={!userIsAdmin}
                  title={!userIsAdmin ? 'Apenas administradores podem editar' : ''}
                >
                  <Edit className="w-4 h-4 mr-1" />
                  Alterar Prazo
                </Button>
                {userIsAdmin && (
                  <Button
                    variant="destructive"
                    size="sm"
                    onClick={() => handleDeleteAtividade(atividadeDetalhe?.id)}
                  >
                    <Trash2 className="w-4 h-4" />
                  </Button>
                )}
              </div>
            </DialogTitle>
          </DialogHeader>
          
          {atividadeDetalhe && (
            <div className="space-y-4">
              <div className="grid grid-cols-3 gap-4">
                <div className="p-3 bg-muted rounded-lg text-center">
                  <div className="text-2xl font-bold text-green-600">
                    {atividadeDetalhe.entregas?.filter(e => e.status === 'entregue' || e.status === 'entregue_atrasado').length || 0}
                  </div>
                  <div className="text-xs text-muted-foreground">Entregues</div>
                </div>
                <div className="p-3 bg-muted rounded-lg text-center">
                  <div className="text-2xl font-bold text-amber-600">
                    {atividadeDetalhe.entregas?.filter(e => e.status === 'pendente').length || 0}
                  </div>
                  <div className="text-xs text-muted-foreground">Pendentes</div>
                </div>
                <div className="p-3 bg-muted rounded-lg text-center">
                  <div className="text-2xl font-bold text-red-600">
                    {atividadeDetalhe.entregas?.filter(e => e.status === 'atrasado').length || 0}
                  </div>
                  <div className="text-xs text-muted-foreground">Atrasados</div>
                </div>
              </div>
              
              <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg">
                <div className="flex items-center gap-2 text-sm">
                  <Calendar className="w-4 h-4 text-amber-600" />
                  <span className="font-medium">Data de Entrega:</span>
                  <span>{new Date(atividadeDetalhe.data_entrega + 'T12:00:00').toLocaleDateString('pt-BR')}</span>
                  <span className="text-muted-foreground">| Pontuação: {atividadeDetalhe.pontuacao_maxima} pts</span>
                </div>
              </div>
              
              {atividadeDetalhe.descricao && (
                <div className="p-3 bg-muted rounded-lg">
                  <p className="text-sm">{atividadeDetalhe.descricao}</p>
                </div>
              )}
              
              <div className="border rounded-lg overflow-hidden">
                <table className="w-full text-sm">
                  <thead className="bg-muted/50">
                    <tr>
                      <th className="text-left p-3 font-medium">Aluno</th>
                      <th className="text-center p-3 font-medium">Status</th>
                      <th className="text-center p-3 font-medium">Entrega</th>
                      <th className="text-center p-3 font-medium">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {atividadeDetalhe.entregas?.map(entrega => (
                      <tr key={entrega.id} className="border-t">
                        <td className="p-3 font-medium">{entrega.student_name}</td>
                        <td className="p-3 text-center">
                          {entrega.status === 'entregue' && (
                            <Badge className="bg-green-100 text-green-800">Entregue</Badge>
                          )}
                          {entrega.status === 'entregue_atrasado' && (
                            <Badge className="bg-amber-100 text-amber-800">Entregue c/ Atraso</Badge>
                          )}
                          {entrega.status === 'pendente' && (
                            <Badge className="bg-blue-100 text-blue-800">Pendente</Badge>
                          )}
                          {entrega.status === 'atrasado' && (
                            <Badge className="bg-red-100 text-red-800">Atrasado</Badge>
                          )}
                        </td>
                        <td className="p-3 text-center text-muted-foreground">
                          {entrega.data_entrega_real ? 
                            new Date(entrega.data_entrega_real).toLocaleDateString('pt-BR') : '-'}
                        </td>
                        <td className="p-3 text-center">
                          {(entrega.status === 'pendente' || entrega.status === 'atrasado') && (
                            <div className="flex justify-center gap-1">
                              <Button
                                size="sm"
                                variant="outline"
                                className="h-7 px-2"
                                onClick={() => handleRegistrarEntrega(entrega.student_id)}
                              >
                                <CheckCircle className="w-3 h-3 mr-1" />
                                Receber
                              </Button>
                              {entrega.status === 'atrasado' && (
                                <Button
                                  size="sm"
                                  variant="outline"
                                  className="h-7 px-2 border-amber-300"
                                  onClick={() => {
                                    setNovoPrazo(atividadeDetalhe.data_entrega);
                                    setAlunoSelecionadoPrazo(entrega.student_id);
                                    setAlterarPrazoDialogOpen(true);
                                  }}
                                  disabled={!userIsAdmin}
                                  title={!userIsAdmin ? 'Apenas administradores podem editar' : ''}
                                >
                                  <Edit className="w-3 h-3" />
                                </Button>
                              )}
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Dialog Alterar Prazo */}
      <Dialog open={alterarPrazoDialogOpen} onOpenChange={setAlterarPrazoDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Edit className="w-5 h-5" />
              Alterar Prazo de Entrega
            </DialogTitle>
            <DialogDescription>
              {alunoSelecionadoPrazo 
                ? 'Alterar prazo apenas para este aluno' 
                : 'Alterar prazo para todos os alunos'}
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <div className="space-y-2">
              <Label>Nova Data de Entrega</Label>
              <Input
                type="date"
                value={novoPrazo}
                onChange={(e) => setNovoPrazo(e.target.value)}
              />
            </div>
            
            {alunoSelecionadoPrazo && (
              <Alert>
                <AlertCircle className="h-4 w-4" />
                <AlertDescription>
                  Esta alteração será aplicada apenas para o aluno selecionado. 
                  Os demais alunos manterão o prazo original.
                </AlertDescription>
              </Alert>
            )}
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => {
              setAlterarPrazoDialogOpen(false);
              setAlunoSelecionadoPrazo(null);
            }}>
              Cancelar
            </Button>
            <Button onClick={handleAlterarPrazo}>
              <Save className="w-4 h-4 mr-2" />
              Salvar Novo Prazo
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Alertas de Atrasados */}
      <Dialog open={alertasDialogOpen} onOpenChange={setAlertasDialogOpen}>
        <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-red-600">
              <AlertTriangle className="w-5 h-5" />
              Alertas de Atividades Atrasadas
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-3">
            {alertasAtrasados.map((alerta, idx) => (
              <div 
                key={idx} 
                className="p-3 border border-red-200 bg-red-50 rounded-lg"
              >
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-medium">{alerta.student_name}</p>
                    <p className="text-sm text-muted-foreground">
                      Atividade: {alerta.atividade_titulo}
                    </p>
                    <p className="text-xs text-red-600 mt-1">
                      {alerta.dias_atraso} dia(s) de atraso
                    </p>
                  </div>
                  <div className="flex gap-2">
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={async () => {
                        const res = await api.get(`/atividades/${alerta.atividade_id}`);
                        setAtividadeDetalhe(res.data);
                        setAlertasDialogOpen(false);
                        setAtividadeDetalheDialogOpen(true);
                      }}
                    >
                      Ver Atividade
                    </Button>
                  </div>
                </div>
              </div>
            ))}
            
            {alertasAtrasados.length === 0 && (
              <div className="text-center p-8 text-muted-foreground">
                <CheckCircle className="w-12 h-12 mx-auto mb-4 text-green-500" />
                <p>Nenhuma atividade atrasada!</p>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Alertas de Reuniões */}
      <Dialog open={alertasReunioesDialogOpen} onOpenChange={setAlertasReunioesDialogOpen}>
        <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-blue-600">
              <Calendar className="w-5 h-5" />
              Minha Agenda de Reuniões
            </DialogTitle>
          </DialogHeader>
          
          <Tabs defaultValue="pendentes" className="w-full">
            <TabsList className="grid w-full grid-cols-2">
              <TabsTrigger value="pendentes" className="relative">
                Convites Pendentes
                {alertasReunioes.total_pendentes > 0 && (
                  <span className="ml-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 inline-flex items-center justify-center">
                    {alertasReunioes.total_pendentes}
                  </span>
                )}
              </TabsTrigger>
              <TabsTrigger value="proximas">
                Próximas Reuniões ({alertasReunioes.total_proximas})
              </TabsTrigger>
            </TabsList>
            
            <TabsContent value="pendentes" className="space-y-3 mt-4">
              {alertasReunioes.pendentes?.length > 0 ? (
                alertasReunioes.pendentes.map((reuniao) => (
                  <div 
                    key={reuniao.convite_id} 
                    className="p-4 border border-amber-200 bg-amber-50 rounded-lg"
                  >
                    <div className="flex justify-between items-start gap-4">
                      <div className="flex-1">
                        <h4 className="font-medium">{reuniao.titulo}</h4>
                        <div className="flex items-center gap-4 mt-2 text-sm text-muted-foreground">
                          <span className="flex items-center gap-1">
                            <Calendar className="w-4 h-4" />
                            {new Date(reuniao.data + 'T12:00:00').toLocaleDateString('pt-BR')}
                          </span>
                          <span className="flex items-center gap-1">
                            <Clock className="w-4 h-4" />
                            {reuniao.hora_inicio} - {reuniao.hora_fim}
                          </span>
                        </div>
                        {reuniao.student_name && (
                          <p className="text-sm mt-1">
                            Aluno: <strong>{reuniao.student_name}</strong>
                          </p>
                        )}
                        {reuniao.local && (
                          <p className="text-sm text-muted-foreground flex items-center gap-1 mt-1">
                            <MapPin className="w-3 h-3" />
                            {reuniao.local}
                          </p>
                        )}
                        {reuniao.assunto && (
                          <p className="text-sm text-muted-foreground mt-1">
                            Assunto: {reuniao.assunto}
                          </p>
                        )}
                      </div>
                      <div className="flex flex-col gap-2">
                        <Button
                          size="sm"
                          className="bg-green-600 hover:bg-green-700"
                          onClick={() => handleResponderConvite(reuniao.convite_id, 'confirmado')}
                        >
                          <CheckCircle className="w-4 h-4 mr-1" />
                          Confirmar
                        </Button>
                        <Button
                          size="sm"
                          variant="outline"
                          className="border-red-300 text-red-600 hover:bg-red-50"
                          onClick={() => handleResponderConvite(reuniao.convite_id, 'recusado')}
                        >
                          <XCircle className="w-4 h-4 mr-1" />
                          Recusar
                        </Button>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center p-8 text-muted-foreground">
                  <CheckCircle className="w-12 h-12 mx-auto mb-4 text-green-500" />
                  <p>Nenhum convite pendente!</p>
                </div>
              )}
            </TabsContent>
            
            <TabsContent value="proximas" className="space-y-3 mt-4">
              {alertasReunioes.proximas?.length > 0 ? (
                alertasReunioes.proximas.map((reuniao) => (
                  <div 
                    key={reuniao.convite_id} 
                    className="p-4 border border-blue-200 bg-blue-50 rounded-lg"
                  >
                    <div className="flex justify-between items-start">
                      <div>
                        <h4 className="font-medium">{reuniao.titulo}</h4>
                        <div className="flex items-center gap-4 mt-2 text-sm text-muted-foreground">
                          <span className="flex items-center gap-1">
                            <Calendar className="w-4 h-4" />
                            {new Date(reuniao.data + 'T12:00:00').toLocaleDateString('pt-BR')}
                          </span>
                          <span className="flex items-center gap-1">
                            <Clock className="w-4 h-4" />
                            {reuniao.hora_inicio} - {reuniao.hora_fim}
                          </span>
                        </div>
                        {reuniao.student_name && (
                          <p className="text-sm mt-1">
                            Aluno: <strong>{reuniao.student_name}</strong>
                          </p>
                        )}
                        {reuniao.local && (
                          <p className="text-sm text-muted-foreground flex items-center gap-1 mt-1">
                            <MapPin className="w-3 h-3" />
                            {reuniao.local}
                          </p>
                        )}
                      </div>
                      <Badge className="bg-green-100 text-green-800">Confirmado</Badge>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center p-8 text-muted-foreground">
                  <Calendar className="w-12 h-12 mx-auto mb-4 opacity-50" />
                  <p>Nenhuma reunião confirmada nos próximos 7 dias</p>
                </div>
              )}
            </TabsContent>
          </Tabs>
          
          <div className="mt-4 pt-4 border-t">
            <Button 
              variant="outline" 
              className="w-full"
              onClick={() => {
                setAlertasReunioesDialogOpen(false);
              }}
            >
              <Calendar className="w-4 h-4 mr-2" />
              Fechar
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Ver Horários - Novo componente moderno */}
      <Dialog open={showScheduleDialog} onOpenChange={setShowScheduleDialog}>
        <DialogContent className="max-w-5xl max-h-[85vh] overflow-y-auto p-0">
          <div className="p-6">
            <TeacherScheduleView 
              employeeId={employeeId} 
              showHeader={true}
            />
          </div>
        </DialogContent>
      </Dialog>

      {/* Alunos em Recuperação — Motor de Notas V2 (centralizado em /equipe/recuperacao) */}
      <FaltantesAprovacaoDialog open={showFaltantes} onOpenChange={setShowFaltantes} scope="teacher" year={new Date().getFullYear()} defaultClassId={selectedClassGroup?.id || selectedClass?.id} />
      <RecuperacaoDialog
        open={showRecuperacaoDialog}
        onOpenChange={setShowRecuperacaoDialog}
        canEditAll={['admin', 'coordenacao'].includes(String(user?.role || '').toLowerCase())}
      />

      {/* Alunos sem Nota — pendências por tipo obrigatório */}
      <AlunosSemNotaDialog
        open={showAlunosSemNotaDialog}
        onOpenChange={setShowAlunosSemNotaDialog}
      />

      {/* Dialog DNA.IA */}
      <Dialog open={showDnaIaDialog} onOpenChange={setShowDnaIaDialog}>
        <DialogContent className="max-w-2xl max-h-[80vh]">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <svg className="w-5 h-5 text-purple-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                <path d="M2 17l10 5 10-5"/>
                <path d="M2 12l10 5 10-5"/>
              </svg>
              DNA.IA - Assistente Inteligente
            </DialogTitle>
            <DialogDescription>
              Faça perguntas sobre pedagogia, planejamento de aulas ou qualquer dúvida relacionada ao ensino.
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            {/* Histórico de mensagens */}
            {dnaIaHistory.length > 0 && (
              <div className="max-h-60 overflow-y-auto space-y-3 p-3 bg-gray-50 rounded-lg">
                {dnaIaHistory.map((msg, idx) => (
                  <div key={idx} className="space-y-2">
                    <div className="bg-purple-100 p-2 rounded-lg">
                      <p className="text-sm font-medium text-purple-800">Você:</p>
                      <p className="text-sm">{msg.question}</p>
                    </div>
                    <div className="bg-white p-2 rounded-lg border">
                      <p className="text-sm font-medium text-green-800">DNA.IA:</p>
                      <p className="text-sm whitespace-pre-wrap">{msg.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
            
            {/* Input de pergunta */}
            <div className="flex gap-2">
              <Textarea
                placeholder="Digite sua pergunta aqui... Ex: Como posso ajudar alunos com dificuldades em matemática?"
                value={dnaIaQuery}
                onChange={(e) => setDnaIaQuery(e.target.value)}
                className="flex-1"
                rows={3}
              />
            </div>
            
            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={() => setShowDnaIaDialog(false)}>
                Fechar
              </Button>
              <Button 
                onClick={handleDnaIaAsk}
                disabled={dnaIaLoading || !dnaIaQuery.trim()}
                className="bg-gradient-to-r from-violet-600 to-purple-600"
              >
                {dnaIaLoading ? (
                  <>
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    Pensando...
                  </>
                ) : (
                  <>
                    <Send className="w-4 h-4 mr-2" />
                    Perguntar
                  </>
                )}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      
      {/* Dialog Justificativa de Ponto */}
      <Dialog open={justificativaDialogOpen} onOpenChange={setJustificativaDialogOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileText className="w-5 h-5 text-orange-600" />
              Justificar Atraso ou Falta
            </DialogTitle>
            <DialogDescription>
              Envie uma justificativa para a coordenação
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label>Data *</Label>
              <Input
                type="date"
                value={justificativaDate}
                onChange={(e) => setJustificativaDate(e.target.value)}
              />
            </div>
            
            <div className="space-y-2">
              <Label>Tipo *</Label>
              <Select value={justificativaTipo} onValueChange={setJustificativaTipo}>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="atraso">
                    <div className="flex items-center gap-2">
                      <Clock className="w-4 h-4 text-amber-500" />
                      Atraso
                    </div>
                  </SelectItem>
                  <SelectItem value="falta">
                    <div className="flex items-center gap-2">
                      <XCircle className="w-4 h-4 text-red-500" />
                      Falta
                    </div>
                  </SelectItem>
                </SelectContent>
              </Select>
            </div>
            
            <div className="space-y-2">
              <Label>Justificativa *</Label>
              <Textarea
                placeholder="Descreva brevemente o motivo do atraso ou falta..."
                value={justificativaTexto}
                onChange={(e) => setJustificativaTexto(e.target.value)}
                rows={3}
                maxLength={500}
              />
              <p className="text-xs text-muted-foreground text-right">
                {justificativaTexto.length}/500 caracteres
              </p>
            </div>
            
            <div className="space-y-2">
              <Label>Atestado (opcional)</Label>
              <div className="border-2 border-dashed rounded-lg p-4 text-center">
                {atestadoFile ? (
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <CheckCircle className="w-5 h-5 text-green-600" />
                      <span className="text-sm truncate max-w-[200px]">{atestadoFile.name}</span>
                    </div>
                    <Button 
                      variant="ghost" 
                      size="sm"
                      onClick={() => setAtestadoFile(null)}
                    >
                      <XCircle className="w-4 h-4" />
                    </Button>
                  </div>
                ) : (
                  <label className="cursor-pointer">
                    <div className="flex flex-col items-center gap-2">
                      <Upload className="w-8 h-8 text-muted-foreground" />
                      <span className="text-sm text-muted-foreground">
                        Clique para anexar atestado médico
                      </span>
                      <span className="text-xs text-muted-foreground">
                        PDF, JPG ou PNG (máx. 5MB)
                      </span>
                    </div>
                    <input
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      className="hidden"
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file) {
                          if (file.size > 5 * 1024 * 1024) {
                            toast.error('Arquivo muito grande. Máximo 5MB.');
                            return;
                          }
                          setAtestadoFile(file);
                        }
                      }}
                    />
                  </label>
                )}
              </div>
            </div>
            
            {/* Informativo sobre análise */}
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
              <p className="text-sm text-blue-800">
                <strong>Importante:</strong> Sua justificativa será analisada pela Coordenação e Direção da escola, 
                que avaliarão o pedido e poderão aprová-lo ou não. Você será notificado sobre o resultado.
              </p>
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setJustificativaDialogOpen(false)}>
              Cancelar
            </Button>
            <Button 
              onClick={handleSubmitJustificativa}
              disabled={!justificativaTexto.trim() || uploadingJustificativa}
              className="bg-orange-600 hover:bg-orange-700"
            >
              {uploadingJustificativa ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Enviando...
                </>
              ) : (
                <>
                  <Send className="w-4 h-4 mr-2" />
                  Enviar Justificativa
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Semana de Avaliações */}
      <Dialog open={showSemanaAvaliacoesDialog} onOpenChange={setShowSemanaAvaliacoesDialog}>
        <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <ClipboardList className="w-5 h-5 text-purple-600" />
              Semana de Avaliações - Minhas Turmas
            </DialogTitle>
            <DialogDescription>
              Visualize as avaliações publicadas para as turmas em que você leciona
            </DialogDescription>
          </DialogHeader>

          {loadingSemanaAvaliacoes ? (
            <div className="flex items-center justify-center py-12">
              <Loader2 className="w-8 h-8 animate-spin text-purple-600" />
            </div>
          ) : semanaAvaliacoes.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-12 text-center">
              <ClipboardList className="w-12 h-12 text-gray-300 mb-4" />
              <h3 className="text-lg font-semibold text-gray-700 mb-2">
                Nenhuma Avaliação Publicada
              </h3>
              <p className="text-gray-500 text-sm">
                Não há semana de avaliações publicada para suas turmas no momento.
              </p>
            </div>
          ) : (
            <div className="space-y-6">
              {semanaAvaliacoes.map((semana) => {
                const avaliacoesPorData = semana.avaliacoes_por_data || {};
                const datas = Object.keys(avaliacoesPorData).sort();
                
                // Extrair horários únicos
                const horariosSet = new Set();
                Object.values(avaliacoesPorData).forEach(avaliacoes => {
                  avaliacoes.forEach(aval => {
                    if (aval.horario) horariosSet.add(aval.horario);
                  });
                });
                const horarios = Array.from(horariosSet).sort((a, b) => {
                  const horaA = a.split(' - ')[0] || '00:00';
                  const horaB = b.split(' - ')[0] || '00:00';
                  return horaA.localeCompare(horaB);
                });

                // Função para cor da disciplina
                const getCorDisciplina = (nome) => {
                  const cores = {
                    'Matemática': { bg: 'bg-green-100', text: 'text-green-800', border: 'border-green-200' },
                    'Língua Portuguesa': { bg: 'bg-yellow-100', text: 'text-yellow-800', border: 'border-yellow-200' },
                    'Ciências': { bg: 'bg-teal-100', text: 'text-teal-800', border: 'border-teal-200' },
                    'História': { bg: 'bg-orange-100', text: 'text-orange-800', border: 'border-orange-200' },
                    'Geografia': { bg: 'bg-yellow-100', text: 'text-yellow-800', border: 'border-yellow-200' },
                    'Educação Física': { bg: 'bg-cyan-100', text: 'text-cyan-800', border: 'border-cyan-200' },
                    'Arte': { bg: 'bg-pink-100', text: 'text-pink-800', border: 'border-pink-200' },
                    'Inglês': { bg: 'bg-blue-100', text: 'text-blue-800', border: 'border-blue-200' },
                    'Espanhol': { bg: 'bg-red-100', text: 'text-red-800', border: 'border-red-200' },
                    'Filosofia': { bg: 'bg-indigo-100', text: 'text-indigo-800', border: 'border-indigo-200' },
                    'Produção Textual': { bg: 'bg-amber-100', text: 'text-amber-800', border: 'border-amber-200' }
                  };
                  for (const [key, value] of Object.entries(cores)) {
                    if (nome?.toLowerCase().includes(key.toLowerCase())) return value;
                  }
                  return { bg: 'bg-gray-100', text: 'text-gray-800', border: 'border-gray-200' };
                };

                const formatarDiaSemana = (dataStr) => {
                  if (!dataStr) return '';
                  const d = new Date(dataStr + 'T12:00:00');
                  const dia = d.toLocaleDateString('pt-BR', { weekday: 'long' });
                  return dia.charAt(0).toUpperCase() + dia.slice(1);
                };

                const formatarDiaMes = (dataStr) => {
                  if (!dataStr) return '';
                  const d = new Date(dataStr + 'T12:00:00');
                  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
                };

                return (
                  <Card key={semana.id} className="overflow-hidden">
                    <div className="bg-gradient-to-r from-purple-600 to-purple-800 text-white p-4">
                      <div className="flex items-center justify-between flex-wrap gap-2">
                        <div>
                          <h3 className="text-lg font-bold">{semana.trimestre}º Trimestre {semana.ano}</h3>
                          <p className="text-purple-200 text-sm">{semana.turma}</p>
                        </div>
                        <Badge className="bg-white/20 text-white border-white/30">
                          <Calendar className="h-3 w-3 mr-1" />
                          {formatarDiaMes(semana.data_inicio)} - {formatarDiaMes(semana.data_fim)}
                        </Badge>
                      </div>
                    </div>

                    <CardContent className="p-0">
                      <div className="overflow-x-auto">
                        <table className="w-full border-collapse min-w-[600px]">
                          <thead>
                            <tr className="bg-gray-100">
                              <th className="border p-2 text-left text-sm font-semibold text-gray-700 w-20">
                                Horário
                              </th>
                              {datas.map(data => (
                                <th key={data} className="border p-2 text-center text-sm font-semibold text-gray-700">
                                  <div className="text-purple-700">{formatarDiaSemana(data)}</div>
                                  <div className="text-xs text-gray-500">{formatarDiaMes(data)}</div>
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {horarios.map(horario => (
                              <tr key={horario} className="hover:bg-gray-50">
                                <td className="border p-2 text-xs text-gray-600 font-medium whitespace-nowrap">
                                  {horario.split(' - ')[0]}
                                  <br />
                                  <span className="text-gray-400">{horario.split(' - ')[1]}</span>
                                </td>
                                {datas.map(data => {
                                  const avaliacoes = avaliacoesPorData[data] || [];
                                  const aval = avaliacoes.find(a => a.horario === horario);
                                  
                                  if (aval) {
                                    const cor = getCorDisciplina(aval.disciplina);
                                    return (
                                      <td key={data} className={`border p-2 ${cor.bg}`}>
                                        <div className={`font-bold text-sm ${cor.text}`}>
                                          {aval.disciplina}
                                        </div>
                                        {aval.professor && (
                                          <div className="text-xs text-gray-600 mt-1">
                                            {aval.professor}
                                          </div>
                                        )}
                                      </td>
                                    );
                                  }
                                  
                                  return (
                                    <td key={data} className="border p-2 bg-gray-50">
                                      <span className="text-gray-300 text-xs">—</span>
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          )}

          <DialogFooter>
            <Button variant="outline" onClick={() => setShowSemanaAvaliacoesDialog(false)}>
              Fechar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      </>
      )}
      </div>
    </div>
  );
}
